/*
 * @Author: Tahiti
 * @Date: 2025-10-21 10:51:20
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-06 19:47:54
 * @Description:
 * @FilePath: /weryai-web/locales/modules/menus.ts
 */
export default {
    zh: {
        menu: '菜单',
        next_billing_date: '会员有效期至：',
        startVip: '立即升级',
        vipBenefits: '享更多权益',
        planEntry: '入门版',
        planBasic: '基础版',
        planPro: '专业版',
        freeUser: '免费用户',
        home: '首页',
        recentlyUsed: '最近使用',
        recentlyUsedDesc: '记录最近20条访问过的页面',
        recentlyUsedEmpty: '暂无访问记录',
        recentlyUsedClear: '清空记录',
        timeJustNow: '刚刚',
        timeMinutesAgo: '{n}分钟前',
        timeHoursAgo: '{n}小时前',
        explore: '探索',
        digitalHuman: '角色',
        AIImages: 'AI 图像',
        AIVideo: 'AI 视频',
        AITools: '编辑工具',
        AIMusic: 'AI 音乐',
        MyCreations: '我的创作',
        textToImage: '文生图',
        imageToImage: '图生图',
        textToVideo: '文生视频',
        imageToVideo: '图生视频',
        imageUpscaler: '图像增强',
        createNew: '新建',
        Creation: '创作',
        videoToVideo: '视频编辑',
        // Create Modal
        createModal: {
            video: '视频',
            image: '图像',
            music: '音乐',
            imageToVideo: '图生视频',
            textToVideo: '文生视频',
            videoEditor: '视频编辑',
            textToImage: '文生图',
            imageToImage: '图生图',
        },
        logout: '退出登录',
        // Explore 页面
        explorePage: {
            imageInspiration: '图片灵感',
            videoInspiration: '视频灵感',
            musicInspiration: '音乐灵感',
            loading: '加载中',
            pleaseWait: '请稍候...',
            loadFailed: '加载失败，请重试',
            noMore: '没有更多内容了',
            noContent: '暂无灵感内容',
        },
        // AppHeader 专用翻译
        videoAI: '视频 AI',
        imageAI: '图像 AI',
        aiTools: '编辑工具',
        pricingLink: '价格',
        login: '登录',
        startFree: '免费开始',
        language: '语言',
        // 语言选项
        chinese: '简体中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        traditional_chinese: '繁體中文',
        polish: 'Polski',
        thai: 'ภาษาไทย',
        danish: 'Dansk',
        norwegian: 'Norsk bokmål',
        dutch: 'Nederlands',
        indonesian: 'Bahasa Indonesia',
        turkish: 'Türkçe',
        billing: '账单',
        addDiscount: '+50%折扣',
        hot: '最热门',
        //
        prompt: '提示词',
        promptPlaceholder: '描述您想要生成的图片内容...',
        creating: '生成中...',
        create: '生成',
        wanAI: 'Wan AI',
        videoEffects: '视频特效',
        photoEffects: '图片特效',
        effects: 'AI 特效',
        music: '音乐',
        generateMusic: '生成音乐',
        // 移动端历史记录输入相关
        inputPlaceholder: '你想生成什么',
        switchCreateType: '切换生成类型',
        imageCategory: '图片',
        videoCategory: '视频',
        musicCategory: '音乐',
        characterImage: '角色生图',
        imageTemplate: '图片模版',
        imageTools: '图片工具',
        characterVideo: '角色生视频',
        videoTemplate: '视频模版',
        videoTools: '视频工具',
        musicGenerate: '音乐生成',
        singleImageReference: '单图参考',
        addImage: '添加图片',
        uploadVideo: '上传视频',
        firstFrame: '首帧',
        lastFrame: '尾帧',
        useThisTemplate: '使用此模板',
        viewAll: '查看所有',
        // 特效分类
        christmasSpecial: '圣诞特惠',
        tiktokTrend: 'TikTok 趋势',
        dance: '跳舞',
        newYear: '新年特惠',
        viral: '病毒性的',
        art: '艺术',
        interactive: '互动',
        trending: '热门',
        portrait: '人像',
        artistic: '艺术风格',
        filter: '滤镜',
        aiDancingTitle: 'AI 舞蹈视频生成器',
        aiKissingTitle: 'AI 接吻视频生成器',
        profile: '个人资料',
        up_to_4k_resolution: '最高支持 4K 分辨率',
        any_aspect_ratio: '任意宽高比',
        smart_online_search: '智能在线搜索',
        control_composition: '构图控制',
        sketch_to_masterpiece: '草图到杰作',
        high_res_output: '高清输出',
        expires: '有效期至',
        // 签到相关
        signInEarnCredits: '签到领积分',
        dailySignIn: '每日签到',
        consecutiveSignInRewards: '累计签到第七天最高可获得50积分',
        day: 'Day',
        claim: '领取',
        claiming: '领取中...',
        claimed: '已领取',
        rechargeForMoreCredits: '充值获取更多积分',
        grandPrize: '大奖',
        claimSuccess: '领取成功',
        noSignInAvailable: '没有可签到的项目',
        signInFailed: '签到失败，请稍后重试',
        discordBound: '已绑定 Discord 账号',
        // 侧边栏分类
        image: '图片',
        video: '视频',
        generateMV: '生成MV',
        textToMusic: '文生音乐',
        // AI音乐页面
        aiMusicPage: {
            title: '音乐生成',
            description: '根据内容生成不同风格的音乐',
            vocalMusic: '人声音乐',
            instrumental: '纯音乐',
            exploreStyles: '探索风格',
            communityCreations: '社区热门创作',
            vocal: '人声',
            instMusic: '纯音乐',
            makeSimilar: '做同款',
        },
        aiMusicSection: {
            title: 'AI 音乐',
        },
        // 文生音乐页面
        textToMusicPage: {
            pleaseEnterDescription: '请输入音乐描述或选择风格',
            taskSubmitted: '音乐生成任务已提交',
            submitFailed: '提交失败',
            createFailed: '音乐生成失败，请稍后重试',
            referenceAudio: '参考音频',
            lyricsPlaceholder: '请输入歌词内容，支持[Verse]、[Chorus]等标记',
        },
        // 音乐风格枚举翻译
        musicStyles: {
            // 曲风
            POP: '流行',
            ROCK: '摇滚',
            RAP: '说唱',
            ELECTRONIC: '电子',
            RNB: 'R&B',
            JAZZ: '爵士',
            FOLK: '民谣',
            CLASSIC: '古典',
            WORLD: '世界音乐',
        },
        // 音乐情感枚举翻译
        musicEmotions: {
            HAPPY: '开心',
            RELAXED: '轻松',
            WARM: '温暖',
            ROMANTIC: '浪漫',
            TOUCHING: '感动',
            SAD: '忧伤',
            LONELY: '孤独',
            DEPRESSED: '压抑',
            TENSE: '紧张',
            EXCITED: '激昂',
            EPIC: '史诗',
            MYSTERIOUS: '神秘',
        },
        // 音乐乐器枚举翻译
        musicInstruments: {
            PIANO: '钢琴',
            GUITAR: '吉他',
            BASS: '贝斯',
            DRUMS: '架子鼓',
            STRINGS: '弦乐',
            WIND: '管乐',
            SYNTHESIZER: '合成器',
            ELECTRONIC_SOUND: '电子音色',
            FOLK_INSTRUMENT: '民族乐器',
            MIXED_ORCHESTRATION: '混合编制',
        },
        // 音乐分类Tab标题
        musicCategories: {
            genre: '曲风',
            emotion: '情感',
            instrument: '乐器',
        },
        shop: '商城',
        footer_home: '首页',
        laboratory: '工具箱',
        mobile_bottom_nav: '手机底部导航',
    },
    en: {
        menu: 'Menu',
        next_billing_date: 'Membership expires on:',
        startVip: 'Upgrade',
        vipBenefits: 'More Benefits',
        planEntry: 'Entry Plan',
        planBasic: 'Basic Plan',
        planPro: 'Pro Plan',
        freeUser: 'Free User',
        home: 'Home',
        recentlyUsed: 'Recently Used',
        recentlyUsedDesc: 'Records of recently visited 20 pages',
        recentlyUsedEmpty: 'No visit records',
        recentlyUsedClear: 'Clear All',
        timeJustNow: 'Just now',
        timeMinutesAgo: '{n}m ago',
        timeHoursAgo: '{n}h ago',
        explore: 'Explore',
        digitalHuman: 'Characters',
        AIImages: 'AI Images',
        AIVideo: 'AI Video',
        AITools: 'Editor Toolkits',
        AIMusic: 'AI Music',
        MyCreations: 'My Creations',
        textToImage: 'Txt2Img',
        imageToImage: 'Img2Img',
        textToVideo: 'Txt2Vid',
        imageToVideo: 'Img2Vid',
        imageUpscaler: 'Image Upscaler',
        createNew: 'Create New',
        Creation: 'Creation',
        videoToVideo: 'Vid2Vid',
        // Create Modal
        createModal: {
            video: 'Video',
            image: 'Image',
            music: 'Music',
            imageToVideo: 'Image to Video',
            textToVideo: 'Text to Video',
            videoEditor: 'Video Editor',
            textToImage: 'Text to Image',
            imageToImage: 'Image to Image',
        },
        logout: 'Logout',
        // Explore page
        explorePage: {
            imageInspiration: 'Image Inspiration',
            videoInspiration: 'Video Inspiration',
            musicInspiration: 'Music Inspiration',
            loading: 'Loading',
            pleaseWait: 'Please wait...',
            loadFailed: 'Failed to load, please try again',
            noMore: 'No more content',
            noContent: 'No inspiration content',
        },
        // AppHeader specific translations
        videoAI: 'VIDEO AI',
        imageAI: 'IMAGE AI',
        aiTools: 'EDITOR TOOLKITS',
        pricingLink: 'PRICING',
        login: 'Login',
        startFree: 'Start Free',
        language: 'Language',
        // Language options
        chinese: '简体中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        traditional_chinese: '繁體中文',
        polish: 'Polski',
        thai: 'ภาษาไทย',
        danish: 'Dansk',
        norwegian: 'Norsk bokmål',
        dutch: 'Nederlands',
        indonesian: 'Bahasa Indonesia',
        turkish: 'Türkçe',
        billing: 'Billing',
        addDiscount: '+50% Discount',
        hot: 'HOT',
        prompt: 'Prompt',
        promptPlaceholder: 'Describe the image content you want to generate...',
        creating: 'Creating...',
        create: 'Create',
        wanAI: 'Wan AI',
        videoEffects: 'Video Effects',
        photoEffects: 'Photo Effects',
        effects: 'AI EFFECTS',
        music: 'Music',
        generateMusic: 'Generate Music',
        // Mobile history input related
        inputPlaceholder: 'What do you want to create',
        switchCreateType: 'Switch Creation Type',
        imageCategory: 'Image',
        videoCategory: 'Video',
        musicCategory: 'Music',
        characterImage: 'Character Image',
        imageTemplate: 'Image Template',
        imageTools: 'Image Tools',
        characterVideo: 'Character Video',
        videoTemplate: 'Video Template',
        videoTools: 'Video Tools',
        musicGenerate: 'Music Generate',
        singleImageReference: 'Image Reference',
        addImage: 'Add Image',
        uploadVideo: 'Upload Video',
        firstFrame: 'First Frame',
        lastFrame: 'Last Frame',
        useThisTemplate: 'Use This Template',
        viewAll: 'View all',
        // Effect categories
        christmasSpecial: 'Christmas Special',
        tiktokTrend: 'TikTok Trend',
        dance: 'Dance',
        newYear: 'New Year Special',
        viral: 'Viral',
        art: 'Art',
        interactive: 'Interactive',
        trending: 'Trending',
        portrait: 'Portrait',
        artistic: 'Artistic',
        filter: 'Filter',
        aiDancingTitle: 'AI Dancing Video Generator',
        aiKissingTitle: 'AI Kissing Video Generator',
        profile: 'Profile',
        up_to_4k_resolution: 'Up to 4K Resolution',
        any_aspect_ratio: 'Any Aspect Ratio',
        smart_online_search: 'Smart Online Search',
        control_composition: 'Control Composition',
        sketch_to_masterpiece: 'Sketch to Masterpiece',
        high_res_output: 'High-Res Output',
        expires: 'Expires on',
        // Sign-in related
        signInEarnCredits: 'Sign In & Earn',
        dailySignIn: 'Daily Check-In',
        consecutiveSignInRewards:
            'Sign in for 7 consecutive days to earn up to 50 credits',
        day: 'Day',
        claim: 'Claim',
        claiming: 'Claiming...',
        claimed: 'Claimed',
        rechargeForMoreCredits: 'Recharge for More Credits',
        grandPrize: 'Prize',
        claimSuccess: 'Claimed successfully',
        noSignInAvailable: 'No check-in available',
        signInFailed: 'Check-in failed, please try again later',
        discordBound: 'Discord account already bound',
        // Sidebar categories
        image: 'Image',
        video: 'Video',
        generateMV: 'Generate MV',
        // Music page
        textToMusic: 'Text to Music',
        // AI Music page
        aiMusicPage: {
            title: 'Music Generation',
            description: 'Generate different styles of music based on content',
            vocalMusic: 'Vocal Music',
            instrumental: 'Instrumental',
            exploreStyles: 'Explore Styles',
            communityCreations: 'Community Creations',
            vocal: 'Vocal',
            instMusic: 'Instrumental',
            makeSimilar: 'Make Similar',
        },
        aiMusicSection: {
            title: 'AI Music',
        },
        // Text to Music page
        textToMusicPage: {
            pleaseEnterDescription:
                'Please enter music description or select style',
            taskSubmitted: 'Music generation task submitted',
            submitFailed: 'Submission failed',
            createFailed: 'Music generation failed, please try again',
            referenceAudio: 'Reference Audio',
            lyricsPlaceholder:
                'Please enter lyrics, supports [Verse], [Chorus] tags, etc.',
        },
        // Music style enums translation
        musicStyles: {
            // Genre
            POP: 'Pop',
            ROCK: 'Rock',
            RAP: 'Rap',
            ELECTRONIC: 'Electronic',
            RNB: 'R&B',
            JAZZ: 'Jazz',
            FOLK: 'Folk',
            CLASSIC: 'Classical',
            WORLD: 'World Music',
        },
        // Music emotion enums translation
        musicEmotions: {
            HAPPY: 'Happy',
            RELAXED: 'Relaxed',
            WARM: 'Warm',
            ROMANTIC: 'Romantic',
            TOUCHING: 'Touching',
            SAD: 'Sad',
            LONELY: 'Lonely',
            DEPRESSED: 'Depressed',
            TENSE: 'Tense',
            EXCITED: 'Excited',
            EPIC: 'Epic',
            MYSTERIOUS: 'Mysterious',
        },
        // Music instrument enums translation
        musicInstruments: {
            PIANO: 'Piano',
            GUITAR: 'Guitar',
            BASS: 'Bass',
            DRUMS: 'Drums',
            STRINGS: 'Strings',
            WIND: 'Wind',
            SYNTHESIZER: 'Synthesizer',
            ELECTRONIC_SOUND: 'Electronic Sound',
            FOLK_INSTRUMENT: 'Folk Instrument',
            MIXED_ORCHESTRATION: 'Mixed Orchestration',
        },
        // Music category tab titles
        musicCategories: {
            genre: 'Genre',
            emotion: 'Emotion',
            instrument: 'Instrument',
        },
        shop: 'Shop',
        footer_home: 'Home',
        laboratory: 'Toolkit',
        mobile_bottom_nav: 'Mobile bottom navigation',
    },
    ja: {
        menu: 'メニュー',
        next_billing_date: '会員有効期限:',
        startVip: 'アップグレード',
        vipBenefits: 'もっと特典を',
        planEntry: 'エントリープラン',
        planBasic: 'ベーシックプラン',
        planPro: 'プロプラン',
        freeUser: '無料ユーザー',
        home: 'ホーム',
        recentlyUsed: '最近の使用',
        recentlyUsedDesc: '最近アクセスした20ページの記録',
        recentlyUsedEmpty: '訪問記録なし',
        recentlyUsedClear: 'すべてクリア',
        timeJustNow: 'たった今',
        timeMinutesAgo: '{n}分前',
        timeHoursAgo: '{n}時間前',
        explore: '探索',
        digitalHuman: 'デジタルヒューマン',
        AIImages: 'AI 画像',
        AIVideo: 'AI 動画',
        AITools: '編集ツールキット',
        AIMusic: 'AI 音楽',
        MyCreations: 'マイクリエーション',
        textToImage: 'テキストから画像',
        imageToImage: '画像から画像',
        textToVideo: 'テキストから動画',
        imageToVideo: '画像から動画',
        imageUpscaler: '画像強化',
        videoToVideo: '動画から動画',
        createNew: '新規作成',
        Creation: 'クリエーション',
        // Create Modal
        createModal: {
            video: '動画',
            image: '画像',
            music: '音楽',
            imageToVideo: '画像から動画',
            textToVideo: 'テキストから動画',
            videoEditor: '動画編集',
            textToImage: 'テキストから画像',
            imageToImage: '画像から画像',
        },
        logout: 'ログアウト',
        // Explore page
        explorePage: {
            imageInspiration: '画像インスピレーション',
            videoInspiration: '動画インスピレーション',
            musicInspiration: '音楽インスピレーション',
            loading: '読み込み中',
            pleaseWait: 'お待ちください...',
            loadFailed: '読み込みに失敗しました。もう一度お試しください',
            noMore: 'これ以上コンテンツはありません',
            noContent: 'インスピレーションコンテンツがありません',
        },
        // AppHeader specific translations
        videoAI: '動画 AI',
        imageAI: '画像 AI',
        aiTools: '編集ツールキット',
        pricingLink: '料金',
        login: 'ログイン',
        startFree: '無料で開始',
        language: '言語',
        // Language options
        chinese: '中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        billing: '請求',
        addDiscount: '+50% 割引',
        hot: '最人気',
        prompt: 'プロンプト',
        promptPlaceholder: '生成したい画像の内容を説明してください...',
        creating: '生成中...',
        create: '生成',
        wanAI: 'Wan AI',
        videoEffects: '動画エフェクト',
        photoEffects: '画像エフェクト',
        effects: 'AIエフェクト',
        music: '音楽',
        generateMusic: '音楽生成',
        // モバイル履歴入力関連
        inputPlaceholder: '何を生成しますか',
        switchCreateType: '生成タイプを切り替え',
        imageCategory: '画像',
        videoCategory: '動画',
        musicCategory: '音楽',
        characterImage: 'キャラクター画像',
        imageTemplate: '画像テンプレート',
        imageTools: '画像ツール',
        characterVideo: 'キャラクター動画',
        videoTemplate: '動画テンプレート',
        videoTools: '動画ツール',
        musicGenerate: '音楽生成',
        useThisTemplate: 'このテンプレートを使用',
        viewAll: 'すべて見る',
        christmasSpecial: 'クリスマス特別',
        tiktokTrend: 'TikTokトレンド',
        dance: 'ダンス',
        newYear: '新年特別',
        viral: 'バイラル',
        art: 'アート',
        interactive: 'インタラクティブ',
        trending: 'トレンド',
        portrait: 'ポートレート',
        artistic: 'アーティスティック',
        filter: 'フィルター',
        aiDancingTitle: 'AIダンス動画ジェネレーター',
        aiKissingTitle: 'AIキス動画ジェネレーター',
        profile: 'プロフィール',
        up_to_4k_resolution: '最大 4K 解像度',
        any_aspect_ratio: '任意のアスペクト比',
        smart_online_search: 'スマートオンライン検索',
        control_composition: '構図コントロール',
        sketch_to_masterpiece: 'スケッチから傑作へ',
        high_res_output: '高解像度出力',
        expires: '有効期限至',
        // サインイン関連
        signInEarnCredits: 'チェックインでポイント獲得',
        dailySignIn: 'デイリーチェックイン',
        consecutiveSignInRewards: '7日間連続チェックインで最大50ポイント獲得',
        day: 'Day',
        claim: '受け取る',
        claiming: '受取中...',
        claimed: '受取済',
        rechargeForMoreCredits: 'チャージしてもっとポイントを獲得',
        grandPrize: '大賞',
        claimSuccess: '受取成功',
        noSignInAvailable: 'チェックイン可能な項目はありません',
        signInFailed: 'チェックインに失敗しました。後でもう一度お試しください',
        discordBound: 'Discord アカウントはすでに連携されています',
        // サイドバーカテゴリ
        image: '画像',
        video: '動画',
        generateMV: 'MV生成',
        // 音楽ページ
        textToMusic: 'テキストから音楽',
        // AI音楽ページ
        aiMusicPage: {
            title: '音楽生成',
            description: 'コンテンツに基づいて異なるスタイルの音楽を生成',
            vocalMusic: 'ボーカル音楽',
            instrumental: 'インストゥルメンタル',
            exploreStyles: 'スタイルを探索',
            communityCreations: 'コミュニティ作品',
            vocal: 'ボーカル',
            instMusic: 'インスト',
            makeSimilar: '同じように作る',
        },
        aiMusicSection: {
            title: 'AI音楽',
        },
        // テキストから音楽ページ
        textToMusicPage: {
            pleaseEnterDescription:
                '音楽の説明を入力するか、スタイルを選択してください',
            taskSubmitted: '音楽生成タスクが送信されました',
            submitFailed: '送信に失敗しました',
            createFailed: '音楽生成に失敗しました。もう一度お試しください',
            referenceAudio: '参考オーディオ',
            lyricsPlaceholder:
                '歌詞を入力してください。[Verse]、[Chorus]などのタグをサポートしています。',
        },
        // 音楽スタイル列挙型翻訳
        musicStyles: {
            // 曲風
            POP: 'ポップ',
            ROCK: 'ロック',
            RAP: 'ラップ',
            ELECTRONIC: 'エレクトロニック',
            RNB: 'R&B',
            JAZZ: 'ジャズ',
            FOLK: 'フォーク',
            CLASSIC: 'クラシック',
            WORLD: 'ワールドミュージック',
        },
        // 音楽感情列挙型翻訳
        musicEmotions: {
            HAPPY: '嬉しい',
            RELAXED: 'リラックス',
            WARM: '温かい',
            ROMANTIC: 'ロマンチック',
            TOUCHING: '感動',
            SAD: '悲しい',
            LONELY: '孤独',
            DEPRESSED: '憂鬱',
            TENSE: '緊張',
            EXCITED: '興奮',
            EPIC: 'エピック',
            MYSTERIOUS: '神秘的',
        },
        // 音楽楽器列挙型翻訳
        musicInstruments: {
            PIANO: 'ピアノ',
            GUITAR: 'ギター',
            BASS: 'ベース',
            DRUMS: 'ドラム',
            STRINGS: '弦楽器',
            WIND: '管楽器',
            SYNTHESIZER: 'シンセサイザー',
            ELECTRONIC_SOUND: '電子音',
            FOLK_INSTRUMENT: '民族楽器',
            MIXED_ORCHESTRATION: '混合編成',
        },
        // 音楽カテゴリタブタイトル
        musicCategories: {
            genre: '曲風',
            emotion: '感情',
            instrument: '楽器',
        },
        shop: 'ショップ',
        footer_home: 'ホーム',
        laboratory: 'ツールキット',
        mobile_bottom_nav: 'モバイルボトムナビゲーション',
    },
    ko: {
        menu: '메뉴',
        next_billing_date: '회원 유효 기간:',
        startVip: '업그레이드',
        vipBenefits: '더 많은 혜택',
        planEntry: '엔트리 플랜',
        planBasic: '베이직 플랜',
        planPro: '프로 플랜',
        freeUser: '무료 사용자',
        home: '홈',
        recentlyUsed: '최근 사용',
        recentlyUsedDesc: '최근 방문한 20개 페이지 기록',
        recentlyUsedEmpty: '방문 기록 없음',
        recentlyUsedClear: '모두 지우기',
        timeJustNow: '방금',
        timeMinutesAgo: '{n}분 전',
        timeHoursAgo: '{n}시간 전',
        explore: '탐색',
        digitalHuman: '디지털 휴먼',
        AIImages: 'AI 이미지',
        AIVideo: 'AI 비디오',
        AITools: '편집 도구 모음',
        AIMusic: 'AI 음악',
        MyCreations: '내 작품',
        textToImage: '텍스트에서 이미지',
        imageToImage: '이미지에서 이미지',
        textToVideo: '텍스트에서 비디오',
        imageToVideo: '이미지에서 비디오',
        imageUpscaler: '이미지 향상',
        videoToVideo: '비디오에서 비디오',
        createNew: '새로 만들기',
        Creation: '작품',
        // Create Modal
        createModal: {
            video: '비디오',
            image: '이미지',
            music: '음악',
            imageToVideo: '이미지에서 비디오',
            textToVideo: '텍스트에서 비디오',
            videoEditor: '비디오 편집',
            textToImage: '텍스트에서 이미지',
            imageToImage: '이미지에서 이미지',
        },
        logout: '로그아웃',
        // Explore page
        explorePage: {
            imageInspiration: '이미지 영감',
            videoInspiration: '비디오 영감',
            musicInspiration: '음악 영감',
            loading: '로딩 중',
            pleaseWait: '잠시 기다려주세요...',
            loadFailed: '로드 실패, 다시 시도해주세요',
            noMore: '더 이상 콘텐츠가 없습니다',
            noContent: '영감 콘텐츠가 없습니다',
        },
        // AppHeader specific translations
        videoAI: '비디오 AI',
        imageAI: '이미지 AI',
        aiTools: '편집 도구 모음',
        pricingLink: '가격',
        login: '로그인',
        startFree: '무료로 시작',
        language: '언어',
        // Language options
        chinese: '中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        billing: '청구',
        addDiscount: '+50% 할인',
        hot: '인기',
        prompt: '프롬프트',
        promptPlaceholder: '생성하려는 이미지 콘텐츠를 설명하세요...',
        creating: '생성 중...',
        create: '생성',
        wanAI: 'Wan AI',
        videoEffects: '비디오 효과',
        photoEffects: '사진 효과',
        effects: 'AI 효과',
        music: '음악',
        generateMusic: '음악 생성',
        // 모바일 히스토리 입력 관련
        inputPlaceholder: '무엇을 만들고 싶으세요',
        switchCreateType: '생성 유형 전환',
        imageCategory: '이미지',
        videoCategory: '비디오',
        musicCategory: '음악',
        characterImage: '캐릭터 이미지',
        imageTemplate: '이미지 템플릿',
        imageTools: '이미지 도구',
        characterVideo: '캐릭터 비디오',
        videoTemplate: '비디오 템플릿',
        videoTools: '비디오 도구',
        musicGenerate: '음악 생성',
        useThisTemplate: '이 템플릿 사용',
        viewAll: '모두 보기',
        christmasSpecial: '크리스마스 특별',
        tiktokTrend: 'TikTok 트렌드',
        dance: '댄스',
        newYear: '새해 특별',
        viral: '바이럴',
        art: '아트',
        interactive: '인터랙티브',
        trending: '인기',
        portrait: '인물',
        artistic: '예술적',
        filter: '필터',
        aiDancingTitle: 'AI 댄스 비디오 생성기',
        aiKissingTitle: 'AI 키스 비디오 생성기',
        profile: '프로필',
        up_to_4k_resolution: '최대 4K 해상도',
        any_aspect_ratio: '어떤 화면비든 가능',
        smart_online_search: '스마트 온라인 검색',
        control_composition: '구도 제어',
        sketch_to_masterpiece: '스케치에서 걸작으로',
        high_res_output: '고해상도 출력',
        expires: '유효 기간 만료일',
        // 체크인 관련
        signInEarnCredits: '체크인하고 포인트 받기',
        dailySignIn: '매일 체크인',
        consecutiveSignInRewards: '7일 연속 체크인하면 최대 50 포인트 획득',
        day: 'Day',
        claim: '받기',
        claiming: '받는 중...',
        claimed: '받음',
        rechargeForMoreCredits: '충전하고 더 많은 포인트 받기',
        grandPrize: '대상',
        claimSuccess: '받기 성공',
        noSignInAvailable: '체크인 가능한 항목 없음',
        signInFailed: '체크인 실패, 나중에 다시 시도해주세요',
        discordBound: 'Discord 계정이 이미 연동되었습니다',
        // 사이드바 카테고리
        image: '이미지',
        video: '비디오',
        generateMV: 'MV 생성',
        // 음악 페이지
        textToMusic: '텍스트를 음악으로',
        // AI 음악 페이지
        aiMusicPage: {
            title: '음악 생성',
            description: '콘텐츠에 따라 다양한 스타일의 음악 생성',
            vocalMusic: '보컬 음악',
            instrumental: '인스트루멘탈',
            exploreStyles: '스타일 탐색',
            communityCreations: '커뮤니티 작품',
            vocal: '보컬',
            instMusic: '인스트루멘탈',
            makeSimilar: '비슷하게 만들기',
        },
        aiMusicSection: {
            title: 'AI 음악',
        },
        // 텍스트에서 음악 페이지
        textToMusicPage: {
            pleaseEnterDescription:
                '음악 설명을 입력하거나 스타일을 선택하세요',
            taskSubmitted: '음악 생성 작업이 제출되었습니다',
            submitFailed: '제출 실패',
            createFailed: '음악 생성에 실패했습니다. 다시 시도해주세요',
            referenceAudio: '참고 오디오',
            lyricsPlaceholder:
                '가사를 입력하세요. [Verse], [Chorus] 등의 태그를 지원합니다.',
        },
        // 음악 스타일 열거형 번역
        musicStyles: {
            // 장르
            POP: '팝',
            ROCK: '록',
            RAP: '랩',
            ELECTRONIC: '일렉트로닉',
            RNB: 'R&B',
            JAZZ: '재즈',
            FOLK: '포크',
            CLASSIC: '클래식',
            WORLD: '월드 뮤직',
        },
        // 음악 감정 열거형 번역
        musicEmotions: {
            HAPPY: '행복한',
            RELAXED: '편안한',
            WARM: '따뜻한',
            ROMANTIC: '로맨틱',
            TOUCHING: '감동적인',
            SAD: '슬픈',
            LONELY: '외로운',
            DEPRESSED: '우울한',
            TENSE: '긴장된',
            EXCITED: '흥분된',
            EPIC: '에픽',
            MYSTERIOUS: '신비로운',
        },
        // 음악 악기 열거형 번역
        musicInstruments: {
            PIANO: '피아노',
            GUITAR: '기타',
            BASS: '베이스',
            DRUMS: '드럼',
            STRINGS: '현악기',
            WIND: '관악기',
            SYNTHESIZER: '신디사이저',
            ELECTRONIC_SOUND: '전자음',
            FOLK_INSTRUMENT: '민속악기',
            MIXED_ORCHESTRATION: '혼합편성',
        },
        // 음악 카테고리 탭 제목
        musicCategories: {
            genre: '장르',
            emotion: '감정',
            instrument: '악기',
        },
        shop: '쇼핑몰',
        footer_home: '홈',
        laboratory: '도구 모음',
        mobile_bottom_nav: '모바일 하단 네비게이션',
    },
    tw: {
        menu: '選單',
        next_billing_date: '會員有效期至：',
        startVip: '立即升級',
        vipBenefits: '享更多權益',
        planEntry: '入門版',
        planBasic: '基礎版',
        planPro: '專業版',
        freeUser: '免費用戶',
        home: '首頁',
        recentlyUsed: '最近使用',
        recentlyUsedDesc: '記錄最近20條訪問過的頁面',
        recentlyUsedEmpty: '暫無訪問記錄',
        recentlyUsedClear: '清空記錄',
        timeJustNow: '剛剛',
        timeMinutesAgo: '{n}分鐘前',
        timeHoursAgo: '{n}小時前',
        explore: '探索',
        digitalHuman: '角色',
        AIImages: 'AI 圖像',
        AIVideo: 'AI 影片',
        AITools: '編輯工具',
        AIMusic: 'AI 音樂',
        MyCreations: '我的創作',
        textToImage: '文生圖',
        imageToImage: '圖生圖',
        textToVideo: '文生影片',
        imageToVideo: '圖生影片',
        imageUpscaler: '圖像增強',
        createNew: '新建',
        Creation: '創作',
        videoToVideo: '影片編輯',
        // Create Modal
        createModal: {
            video: '影片',
            image: '圖像',
            music: '音樂',
            imageToVideo: '圖生影片',
            textToVideo: '文生影片',
            videoEditor: '影片編輯',
            textToImage: '文生圖',
            imageToImage: '圖生圖',
        },
        logout: '退出登錄',
        // Explore 頁面
        explorePage: {
            imageInspiration: '圖片靈感',
            videoInspiration: '影片靈感',
            musicInspiration: '音樂靈感',
            loading: '載入中',
            pleaseWait: '請稍候...',
            loadFailed: '載入失敗，請重試',
            noMore: '沒有更多內容了',
            noContent: '暫無靈感內容',
        },
        // AppHeader 專用翻譯
        videoAI: '影片 AI',
        imageAI: '圖像 AI',
        aiTools: '編輯工具',
        pricingLink: '價格',
        login: '登錄',
        startFree: '免費開始',
        language: '語言',
        // 语言选项
        chinese: '中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        billing: '賬單',
        addDiscount: '+50%折扣',
        hot: '最熱門',
        //
        prompt: '提示詞',
        promptPlaceholder: '描述您想要生成的圖片內容...',
        creating: '生成中...',
        create: '生成',
        wanAI: 'Wan AI',
        videoEffects: '影片特效',
        photoEffects: '圖片特效',
        effects: 'AI 特效',
        useThisTemplate: '使用此模板',
        viewAll: '查看所有',
        // 移动端历史记录输入相关
        inputPlaceholder: '你想生成什麼',
        switchCreateType: '切換生成類型',
        imageCategory: '圖片',
        videoCategory: '影片',
        musicCategory: '音樂',
        characterImage: '角色生圖',
        imageTemplate: '圖片模版',
        imageTools: '圖片工具',
        characterVideo: '角色生影片',
        videoTemplate: '影片模版',
        videoTools: '影片工具',
        musicGenerate: '音樂生成',
        singleImageReference: '單圖參考',
        addImage: '添加圖片',
        // 特效分类
        christmasSpecial: '聖誕特惠',
        tiktokTrend: 'TikTok 趨勢',
        dance: '舞蹈',
        newYear: '新年特惠',
        viral: '熱門',
        art: '藝術',
        interactive: '互動',
        trending: '熱門',
        portrait: '人像',
        artistic: '艺术风格',
        filter: '滤镜',
        aiDancingTitle: 'AI 舞蹈视频生成器',
        aiKissingTitle: 'AI 接吻视频生成器',
        profile: '个人资料',
        up_to_4k_resolution: '最高支持 4K 分辨率',
        any_aspect_ratio: '任意宽高比',
        smart_online_search: '智能在线搜索',
        control_composition: '构图控制',
        sketch_to_masterpiece: '草图到杰作',
        high_res_output: '高清输出',
        expires: '有效期至',
        // 签到相关
        signInEarnCredits: '签到领积分',
        dailySignIn: '每日签到',
        consecutiveSignInRewards: '累计签到第七天最高可获得50积分',
        day: 'Day',
        claim: '领取',
        claiming: '领取中...',
        claimed: '已领取',
        rechargeForMoreCredits: '充值获取更多积分',
        grandPrize: '大奖',
        claimSuccess: '领取成功',
        noSignInAvailable: '没有可签到的项目',
        signInFailed: '签到失败，请稍后重试',
        // 侧边栏分类
        image: '图片',
        video: '视频',
        music: '音乐',
        generateMusic: '生成音乐',
        generateMV: '生成MV',
        textToMusic: '文生音乐',
        // AI音乐页面
        aiMusicPage: {
            title: '音乐生成',
            description: '根据内容生成不同风格的音乐',
            vocalMusic: '人声音乐',
            instrumental: '纯音乐',
            exploreStyles: '探索风格',
            communityCreations: '社区热门创作',
            vocal: '人声',
            instMusic: '纯音乐',
            makeSimilar: '做同款',
        },
        aiMusicSection: {
            title: 'AI 音乐',
        },
        // 文生音乐页面
        textToMusicPage: {
            pleaseEnterDescription: '请输入音乐描述或选择风格',
            taskSubmitted: '音乐生成任务已提交',
            submitFailed: '提交失败',
            createFailed: '音乐生成失败，请稍后重试',
            referenceAudio: '参考音频',
            lyricsPlaceholder: '请输入歌词内容，支持[Verse]、[Chorus]等标记',
        },
        // 音乐风格枚举翻译
        musicStyles: {
            // 曲风
            POP: '流行',
            ROCK: '摇滚',
            RAP: '说唱',
            ELECTRONIC: '电子',
            RNB: 'R&B',
            JAZZ: '爵士',
            FOLK: '民谣',
            CLASSIC: '古典',
            WORLD: '世界音乐',
        },
        // 音乐情感枚举翻译
        musicEmotions: {
            HAPPY: '开心',
            RELAXED: '轻松',
            WARM: '温暖',
            ROMANTIC: '浪漫',
            TOUCHING: '感动',
            SAD: '忧伤',
            LONELY: '孤独',
            DEPRESSED: '压抑',
            TENSE: '紧张',
            EXCITED: '激昂',
            EPIC: '史诗',
            MYSTERIOUS: '神秘',
        },
        // 音乐乐器枚举翻译
        musicInstruments: {
            PIANO: '钢琴',
            GUITAR: '吉他',
            BASS: '贝斯',
            DRUMS: '架子鼓',
            STRINGS: '弦乐',
            WIND: '管乐',
            SYNTHESIZER: '合成器',
            ELECTRONIC_SOUND: '电子音色',
            FOLK_INSTRUMENT: '民族乐器',
            MIXED_ORCHESTRATION: '混合编制',
        },
        // 音乐分类Tab标题
        musicCategories: {
            genre: '曲风',
            emotion: '情感',
            instrument: '乐器',
        },
        shop: '商城',
        footer_home: '首頁',
        laboratory: '工具箱',
        mobile_bottom_nav: '手機底部導航',
    },
    pl: {
        menu: 'Menu',
        next_billing_date: 'Ważność członkostwa do:',
        startVip: 'Ulepsz teraz',
        vipBenefits: 'Więcej korzyści',
        planEntry: 'Plan startowy',
        planBasic: 'Plan podstawowy',
        planPro: 'Plan Pro',
        freeUser: 'Użytkownik darmowy',
        home: 'Strona główna',
        recentlyUsed: 'Ostatnio używane',
        recentlyUsedDesc: 'Rekordy 20 ostatnio odwiedzonych stron',
        recentlyUsedEmpty: 'Brak zapisów odwiedzin',
        recentlyUsedClear: 'Wyczyść wszystko',
        timeJustNow: 'Przed chwilą',
        timeMinutesAgo: '{n}min temu',
        timeHoursAgo: '{n}godz. temu',
        explore: 'Eksploruj',
        digitalHuman: 'Postacie',
        AIImages: 'AI Obrazy',
        AIVideo: 'AI Wideo',
        AITools: 'Narzędzia',
        AIMusic: 'AI Muzyka',
        MyCreations: 'Moje kreacje',
        textToImage: 'Tekst na obraz',
        imageToImage: 'Obraz na obraz',
        textToVideo: 'Tekst na wideo',
        imageToVideo: 'Obraz na wideo',
        imageUpscaler: 'Ulepszanie obrazu',
        createNew: 'Nowy',
        Creation: 'Tworzenie',
        videoToVideo: 'Edycja wideo',
        // Create Modal
        createModal: {
            video: 'Wideo',
            image: 'Obraz',
            music: 'Muzyka',
            imageToVideo: 'Obraz→Wideo',
            textToVideo: 'Tekst→Wideo',
            videoEditor: 'Edytor wideo',
            textToImage: 'Tekst→Obraz',
            imageToImage: 'Obraz→Obraz',
        },
        logout: 'Wyloguj',
        // Strona Explore
        explorePage: {
            imageInspiration: 'Inspiracje obrazami',
            videoInspiration: 'Inspiracje wideo',
            musicInspiration: 'Inspiracje muzyczne',
            loading: 'Ładowanie',
            pleaseWait: 'Proszę czekać...',
            loadFailed: 'Ładowanie nie powiodło się, spróbuj ponownie',
            noMore: 'Nie ma więcej treści',
            noContent: 'Brak inspiracji',
        },
        // AppHeader specific translations
        videoAI: 'Wideo AI',
        imageAI: 'Obraz AI',
        aiTools: 'Narzędzia AI',
        pricingLink: 'Cennik',
        login: 'Zaloguj',
        startFree: 'Zacznij za darmo',
        language: 'Język',
        // Language options
        chinese: '中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        billing: 'Rozliczenia',
        addDiscount: '+50% zniżki',
        hot: 'Gorące',
        prompt: 'Prompt',
        promptPlaceholder: 'Opisz obraz...',
        creating: 'Generowanie...',
        create: 'Utwórz',
        wanAI: 'Wan AI',
        videoEffects: 'Efekty wideo',
        photoEffects: 'Efekty zdjęć',
        effects: 'Efekty AI',
        useThisTemplate: 'Użyj szablonu',
        viewAll: 'Zobacz wszystko',
        // Mobile history input related
        inputPlaceholder: 'Co chcesz utworzyć',
        switchCreateType: 'Zmień typ kreacji',
        imageCategory: 'Obraz',
        videoCategory: 'Wideo',
        musicCategory: 'Muzyka',
        characterImage: 'Obraz postaci',
        imageTemplate: 'Szablon obrazu',
        imageTools: 'Narzędzia obrazu',
        characterVideo: 'Wideo postaci',
        videoTemplate: 'Szablon wideo',
        videoTools: 'Narzędzia wideo',
        musicGenerate: 'Generuj muzykę',
        singleImageReference: 'Pojedynczy obraz',
        addImage: 'Dodaj obraz',
        // Effect categories
        christmasSpecial: 'Świąteczna oferta',
        tiktokTrend: 'Trend TikTok',
        dance: 'Taniec',
        newYear: 'Noworoczna oferta',
        viral: 'Viralowe',
        art: 'Sztuka',
        interactive: 'Interaktywne',
        trending: 'Na topie',
        portrait: 'Portret',
        artistic: 'Artistic',
        filter: 'Filter',
        aiDancingTitle: 'AI Dancing Video Generator',
        aiKissingTitle: 'AI Kissing Video Generator',
        profile: 'Profile',
        up_to_4k_resolution: 'Up to 4K Resolution',
        any_aspect_ratio: 'Any Aspect Ratio',
        smart_online_search: 'Smart Online Search',
        control_composition: 'Control Composition',
        sketch_to_masterpiece: 'Sketch to Masterpiece',
        high_res_output: 'High-Res Output',
        expires: 'Expires on',
        // Sign-in related
        signInEarnCredits: 'Sign In & Earn',
        dailySignIn: 'Daily Check-In',
        consecutiveSignInRewards:
            'Sign in for 7 consecutive days to earn up to 50 credits',
        day: 'Day',
        claim: 'Claim',
        claiming: 'Claiming...',
        claimed: 'Claimed',
        rechargeForMoreCredits: 'Recharge for More Credits',
        grandPrize: 'Prize',
        claimSuccess: 'Claimed successfully',
        noSignInAvailable: 'No check-in available',
        signInFailed: 'Check-in failed, please try again later',
        // Sidebar categories
        image: 'Image',
        video: 'Video',
        music: 'Music',
        generateMusic: 'Generate Music',
        generateMV: 'Generate MV',
        // Music page
        textToMusic: 'Text to Music',
        // AI Music page
        aiMusicPage: {
            title: 'Music Generation',
            description: 'Generate different styles of music based on content',
            vocalMusic: 'Vocal Music',
            instrumental: 'Instrumental',
            exploreStyles: 'Explore Styles',
            communityCreations: 'Community Creations',
            vocal: 'Vocal',
            instMusic: 'Instrumental',
            makeSimilar: 'Make Similar',
        },
        aiMusicSection: {
            title: 'AI Music',
        },
        // Text to Music page
        textToMusicPage: {
            pleaseEnterDescription:
                'Please enter music description or select style',
            taskSubmitted: 'Music generation task submitted',
            submitFailed: 'Submission failed',
            createFailed: 'Music generation failed, please try again',
            referenceAudio: 'Reference Audio',
            lyricsPlaceholder:
                'Please enter lyrics, supports [Verse], [Chorus] tags, etc.',
        },
        // Music style enums translation
        musicStyles: {
            // Genre
            POP: 'Pop',
            ROCK: 'Rock',
            RAP: 'Rap',
            ELECTRONIC: 'Electronic',
            RNB: 'R&B',
            JAZZ: 'Jazz',
            FOLK: 'Folk',
            CLASSIC: 'Classical',
            WORLD: 'World Music',
        },
        // Music emotion enums translation
        musicEmotions: {
            HAPPY: 'Happy',
            RELAXED: 'Relaxed',
            WARM: 'Warm',
            ROMANTIC: 'Romantic',
            TOUCHING: 'Touching',
            SAD: 'Sad',
            LONELY: 'Lonely',
            DEPRESSED: 'Depressed',
            TENSE: 'Tense',
            EXCITED: 'Excited',
            EPIC: 'Epic',
            MYSTERIOUS: 'Mysterious',
        },
        // Music instrument enums translation
        musicInstruments: {
            PIANO: 'Piano',
            GUITAR: 'Guitar',
            BASS: 'Bass',
            DRUMS: 'Drums',
            STRINGS: 'Strings',
            WIND: 'Wind',
            SYNTHESIZER: 'Synthesizer',
            ELECTRONIC_SOUND: 'Electronic Sound',
            FOLK_INSTRUMENT: 'Folk Instrument',
            MIXED_ORCHESTRATION: 'Mixed Orchestration',
        },
        // Music category tab titles
        musicCategories: {
            genre: 'Gatunek',
            emotion: 'Emocja',
            instrument: 'Instrument',
        },
        shop: 'Sklep',
        footer_home: 'Strona główna',
        laboratory: 'Zestaw narzędzi',
        mobile_bottom_nav: 'Mobilna dolna nawigacja',
    },
    es: {
        menu: 'Menú',
        next_billing_date: 'Período de membresía:',
        startVip: 'Mejorar Plan',
        vipBenefits: 'Más beneficios',
        planEntry: 'Plan de entrada',
        planBasic: 'Plan básico',
        planPro: 'Plan Pro',
        freeUser: 'Usuario gratuito',
        home: 'Inicio',
        recentlyUsed: 'Usados recientemente',
        recentlyUsedDesc: 'Registros de las últimas 20 páginas visitadas',
        recentlyUsedEmpty: 'Sin registros de visita',
        recentlyUsedClear: 'Borrar todo',
        timeJustNow: 'Ahora mismo',
        timeMinutesAgo: 'Hace {n}m',
        timeHoursAgo: 'Hace {n}h',
        explore: 'Explorar',
        digitalHuman: 'Humano Digital',
        AIImages: 'Imágenes AI',
        AIVideo: 'Video AI',
        AITools: 'Kit de herramientas de edición',
        AIMusic: 'AI Música',
        MyCreations: 'Mis Creaciones',
        textToImage: 'Texto a Imagen',
        imageToImage: 'Imagen a Imagen',
        textToVideo: 'Texto a Video',
        imageToVideo: 'Imagen a Video',
        imageUpscaler: 'Mejorador de Imágenes',
        videoToVideo: 'Video a Video',
        createNew: 'Crear Nuevo',
        Creation: 'Creación',
        // Create Modal
        createModal: {
            video: 'Video',
            image: 'Imagen',
            music: 'Música',
            imageToVideo: 'Imagen a Video',
            textToVideo: 'Texto a Video',
            videoEditor: 'Editor de Video',
            textToImage: 'Texto a Imagen',
            imageToImage: 'Imagen a Imagen',
        },
        logout: 'Cerrar Sesión',
        // Explore page
        explorePage: {
            imageInspiration: 'Inspiración de Imagen',
            videoInspiration: 'Inspiración de Video',
            musicInspiration: 'Inspiración Musical',
            loading: 'Cargando',
            pleaseWait: 'Por favor espere...',
            loadFailed: 'Error al cargar, por favor intente de nuevo',
            noMore: 'No hay más contenido',
            noContent: 'Sin contenido de inspiración',
        },
        // AppHeader specific translations
        videoAI: 'Video AI',
        imageAI: 'Imagen AI',
        aiTools: 'Kit de herramientas de edición',
        pricingLink: 'Precios',
        login: 'Iniciar Sesión',
        startFree: 'Comenzar Gratis',
        language: 'Idioma',
        // Language options
        chinese: '中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        billing: 'Facturación',
        addDiscount: '+50% Descuento',
        hot: 'Más popular',
        prompt: 'Prompt',
        promptPlaceholder:
            'Describe el contenido de la imagen que quieres generar...',
        creating: 'Creando...',
        create: 'Crear',
        wanAI: 'Wan AI',
        videoEffects: 'Efectos de video',
        photoEffects: 'Efectos de foto',
        effects: 'AI EFECTOS',
        music: 'Música',
        generateMusic: 'Generar música',
        // Entrada de historial móvil relacionada
        inputPlaceholder: '¿Qué quieres crear?',
        switchCreateType: 'Cambiar tipo de creación',
        imageCategory: 'Imagen',
        videoCategory: 'Video',
        musicCategory: 'Música',
        characterImage: 'Imagen de personaje',
        imageTemplate: 'Plantilla de imagen',
        imageTools: 'Herramientas de imagen',
        characterVideo: 'Video de personaje',
        videoTemplate: 'Plantilla de video',
        videoTools: 'Herramientas de video',
        musicGenerate: 'Generar música',
        useThisTemplate: 'Usar esta plantilla',
        viewAll: 'Ver todos',
        christmasSpecial: 'Especial de Navidad',
        tiktokTrend: 'Tendencia TikTok',
        dance: 'Baile',
        newYear: 'Especial de Año Nuevo',
        viral: 'Viral',
        art: 'Arte',
        interactive: 'Interactivo',
        trending: 'Tendencia',
        portrait: 'Retrato',
        artistic: 'Artístico',
        filter: 'Filtro',
        aiDancingTitle: 'Generador de Vídeo de Baile AI',
        aiKissingTitle: 'Generador de Videos de Besos con IA',
        profile: 'Perfil',
        up_to_4k_resolution: 'Hasta resolución 4K',
        any_aspect_ratio: 'Cualquier relación de aspecto',
        smart_online_search: 'Búsqueda inteligente en línea',
        control_composition: 'Control de composición',
        sketch_to_masterpiece: 'De boceto a obra maestra',
        high_res_output: 'Salida en alta resolución',
        expires: 'Vence el',
        // Relacionado con el check-in
        signInEarnCredits: 'Check-in y Ganar',
        dailySignIn: 'Check-in Diario',
        consecutiveSignInRewards:
            'Regístrate durante 7 días consecutivos para ganar hasta 50 créditos',
        day: 'Día',
        claim: 'Reclamar',
        claiming: 'Reclamando...',
        claimed: 'Reclamado',
        rechargeForMoreCredits: 'Recargar para Más Créditos',
        grandPrize: 'Premio',
        claimSuccess: 'Reclamado con éxito',
        noSignInAvailable: 'No hay check-in disponible',
        signInFailed: 'Check-in falló, por favor inténtelo de nuevo más tarde',
        discordBound: 'La cuenta de Discord ya está vinculada',
        // Categorías de la barra lateral
        image: 'Imagen',
        video: 'Video',
        generateMV: 'Generar MV',
        // Página de música
        textToMusic: 'Texto a Música',
        // Página de AI Música
        aiMusicPage: {
            title: 'Generación de Música',
            description:
                'Genera diferentes estilos de música según el contenido',
            vocalMusic: 'Música Vocal',
            instrumental: 'Instrumental',
            exploreStyles: 'Explorar Estilos',
            communityCreations: 'Creaciones de la Comunidad',
            vocal: 'Vocal',
            instMusic: 'Instrumental',
            makeSimilar: 'Crear Similar',
        },
        aiMusicSection: {
            title: 'Música IA',
        },
        // Página de Texto a Música
        textToMusicPage: {
            pleaseEnterDescription:
                'Por favor ingresa una descripción de música o selecciona un estilo',
            taskSubmitted: 'Tarea de generación de música enviada',
            submitFailed: 'Envío fallido',
            createFailed:
                'La generación de música falló, por favor intenta de nuevo',
            referenceAudio: 'Audio de Referencia',
            lyricsPlaceholder:
                'Ingrese la letra, admite etiquetas [Verse], [Chorus], etc.',
        },
        // Traducción de estilos de música
        musicStyles: {
            // Género
            POP: 'Pop',
            ROCK: 'Rock',
            RAP: 'Rap',
            ELECTRONIC: 'Electrónica',
            RNB: 'R&B',
            JAZZ: 'Jazz',
            FOLK: 'Folk',
            CLASSIC: 'Clásica',
            WORLD: 'Música del Mundo',
        },
        // Traducción de emociones musicales
        musicEmotions: {
            HAPPY: 'Feliz',
            RELAXED: 'Relajado',
            WARM: 'Cálido',
            ROMANTIC: 'Romántico',
            TOUCHING: 'Conmovedor',
            SAD: 'Triste',
            LONELY: 'Solitario',
            DEPRESSED: 'Deprimido',
            TENSE: 'Tenso',
            EXCITED: 'Emocionado',
            EPIC: 'Épico',
            MYSTERIOUS: 'Misterioso',
        },
        // Traducción de instrumentos musicales
        musicInstruments: {
            PIANO: 'Piano',
            GUITAR: 'Guitarra',
            BASS: 'Bajo',
            DRUMS: 'Batería',
            STRINGS: 'Cuerdas',
            WIND: 'Viento',
            SYNTHESIZER: 'Sintetizador',
            ELECTRONIC_SOUND: 'Sonido Electrónico',
            FOLK_INSTRUMENT: 'Instrumento Folclórico',
            MIXED_ORCHESTRATION: 'Orquestación Mixta',
        },
        // Títulos de pestañas de categorías musicales
        musicCategories: {
            genre: 'Género',
            emotion: 'Emoción',
            instrument: 'Instrumento',
        },
        shop: 'Tienda',
        footer_home: 'Inicio',
        laboratory: 'Kit de herramientas',
        mobile_bottom_nav: 'Navegación inferior móvil',
    },
    fr: {
        menu: 'Menu',
        next_billing_date: 'Période de membreship:',
        startVip: 'Surclasser',
        vipBenefits: "Plus d'avantages",
        planEntry: "Plan d'entrée",
        planBasic: 'Plan de base',
        planPro: 'Plan Pro',
        freeUser: 'Utilisateur gratuit',
        home: 'Accueil',
        recentlyUsed: 'Utilisés récemment',
        recentlyUsedDesc: 'Enregistrements des 20 dernières pages visitées',
        recentlyUsedEmpty: 'Aucun enregistrement de visite',
        recentlyUsedClear: 'Tout effacer',
        timeJustNow: "À l'instant",
        timeMinutesAgo: 'Il y a {n}m',
        timeHoursAgo: 'Il y a {n}h',
        explore: 'Explorer',
        digitalHuman: 'Humain Numérique',
        AIImages: 'Images IA',
        AIVideo: 'Vidéo IA',
        AITools: "Kit d'outils d'édition",
        AIMusic: 'IA Musique',
        MyCreations: 'Mes Créations',
        textToImage: 'Texte vers Image',
        imageToImage: 'Image vers Image',
        textToVideo: 'Texte vers Vidéo',
        imageToVideo: 'Image vers Vidéo',
        imageUpscaler: "Amélioration d'Image",
        videoToVideo: 'Vidéo vers Vidéo',
        createNew: 'Créer Nouveau',
        Creation: 'Création',
        // Create Modal
        createModal: {
            video: 'Vidéo',
            image: 'Image',
            music: 'Musique',
            imageToVideo: 'Image vers Vidéo',
            textToVideo: 'Texte vers Vidéo',
            videoEditor: 'Éditeur de Vidéo',
            textToImage: 'Texte vers Image',
            imageToImage: 'Image vers Image',
        },
        logout: 'Déconnexion',
        // Explore page
        explorePage: {
            imageInspiration: 'Inspiration Image',
            videoInspiration: 'Inspiration Vidéo',
            musicInspiration: 'Inspiration Musicale',
            loading: 'Chargement',
            pleaseWait: 'Veuillez patienter...',
            loadFailed: 'Échec du chargement, veuillez réessayer',
            noMore: 'Plus de contenu',
            noContent: 'Aucun contenu d\'inspiration',
        },
        // AppHeader specific translations
        videoAI: 'Vidéo IA',
        imageAI: 'Image IA',
        aiTools: "Kit d'outils d'édition",
        pricingLink: 'Tarifs',
        login: 'Connexion',
        startFree: 'Commencer Gratuitement',
        language: 'Langue',
        // Language options
        chinese: '中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        billing: 'Facturation',
        addDiscount: '+50% Remise',
        hot: 'Plus populaire',
        prompt: 'Prompt',
        promptPlaceholder:
            "Décrivez le contenu de l'image que vous souhaitez générer...",
        creating: 'Création...',
        create: 'Créer',
        wanAI: 'Wan AI',
        videoEffects: 'Effets vidéo',
        photoEffects: 'Effets photo',
        effects: 'AI EFFETS',
        music: 'Musique',
        generateMusic: 'Générer de la musique',
        // Entrée d'historique mobile associée
        inputPlaceholder: 'Que voulez-vous créer ?',
        switchCreateType: 'Changer le type de création',
        imageCategory: 'Image',
        videoCategory: 'Vidéo',
        musicCategory: 'Musique',
        characterImage: 'Image de personnage',
        imageTemplate: 'Modèle d\'image',
        imageTools: 'Outils d\'image',
        characterVideo: 'Vidéo de personnage',
        videoTemplate: 'Modèle de vidéo',
        videoTools: 'Outils vidéo',
        musicGenerate: 'Générer de la musique',
        useThisTemplate: 'Utiliser ce modèle',
        viewAll: 'Voir tout',
        christmasSpecial: 'Spécial Noël',
        tiktokTrend: 'Tendance TikTok',
        dance: 'Danse',
        newYear: 'Spécial Nouvel An',
        viral: 'Viral',
        art: 'Art',
        interactive: 'Interactif',
        trending: 'Tendance',
        portrait: 'Portrait',
        artistic: 'Artistique',
        filter: 'Filtre',
        aiDancingTitle: 'Générateur de Vidéo de Danse IA',
        aiKissingTitle: 'Générateur de Vidéos de Baisers IA',
        up_to_4k_resolution: "Jusqu'à la résolution 4K",
        any_aspect_ratio: "Tout format d'image",
        smart_online_search: 'Recherche intelligente en ligne',
        control_composition: 'Contrôle de la composition',
        sketch_to_masterpiece: 'Du croquis au chef-d’œuvre',
        high_res_output: 'Sortie haute résolution',
        expires: 'Expire le',
        // Relatif au check-in
        signInEarnCredits: 'Se Connecter et Gagner',
        dailySignIn: 'Enregistrement Quotidien',
        consecutiveSignInRewards:
            "Enregistrez-vous pendant 7 jours consécutifs pour gagner jusqu'à 50 crédits",
        day: 'Jour',
        claim: 'Réclamer',
        claiming: 'Réclamation...',
        claimed: 'Réclamé',
        rechargeForMoreCredits: 'Recharger pour Plus de Crédits',
        grandPrize: 'Prix',
        claimSuccess: 'Réclamé avec succès',
        noSignInAvailable: "Aucun enregistrement n'est disponible",
        signInFailed: "L'enregistrement a échoué, veuillez réessayer plus tard",
        discordBound: 'Compte Discord déjà lié',
        // Catégories de la barre latérale
        image: 'Image',
        video: 'Vidéo',
        generateMV: 'Générer MV',
        textToMusic: 'Texte vers Musique',
        // Page AI Musique
        aiMusicPage: {
            title: 'Génération de Musique',
            description:
                'Générer différents styles de musique selon le contenu',
            vocalMusic: 'Musique Vocale',
            instrumental: 'Instrumental',
            exploreStyles: 'Explorer les Styles',
            communityCreations: 'Créations de la Communauté',
            vocal: 'Vocal',
            instMusic: 'Instrumental',
            makeSimilar: 'Créer Similaire',
        },
        aiMusicSection: {
            title: 'Musique IA',
        },
        // Page Texte vers Musique
        textToMusicPage: {
            pleaseEnterDescription:
                'Veuillez entrer une description de musique ou sélectionner un style',
            taskSubmitted: 'Tâche de génération de musique soumise',
            submitFailed: 'Échec de la soumission',
            createFailed:
                'La génération de musique a échoué, veuillez réessayer',
            referenceAudio: 'Audio de Référence',
            lyricsPlaceholder:
                'Veuillez saisir les paroles, prend en charge les balises [Verse], [Chorus], etc.',
        },
        // Traduction des styles de musique
        musicStyles: {
            // Genre
            POP: 'Pop',
            ROCK: 'Rock',
            RAP: 'Rap',
            ELECTRONIC: 'Électronique',
            RNB: 'R&B',
            JAZZ: 'Jazz',
            FOLK: 'Folk',
            CLASSIC: 'Classique',
            WORLD: 'Musique du Monde',
        },
        // Traduction des émotions musicales
        musicEmotions: {
            HAPPY: 'Joyeux',
            RELAXED: 'Détendu',
            WARM: 'Chaleureux',
            ROMANTIC: 'Romantique',
            TOUCHING: 'Émouvant',
            SAD: 'Triste',
            LONELY: 'Solitaire',
            DEPRESSED: 'Déprimé',
            TENSE: 'Tendu',
            EXCITED: 'Excité',
            EPIC: 'Épique',
            MYSTERIOUS: 'Mystérieux',
        },
        // Traduction des instruments de musique
        musicInstruments: {
            PIANO: 'Piano',
            GUITAR: 'Guitare',
            BASS: 'Basse',
            DRUMS: 'Batterie',
            STRINGS: 'Cordes',
            WIND: 'Vent',
            SYNTHESIZER: 'Synthétiseur',
            ELECTRONIC_SOUND: 'Son Électronique',
            FOLK_INSTRUMENT: 'Instrument Folklorique',
            MIXED_ORCHESTRATION: 'Orchestration Mixte',
        },
        // Titres des onglets de catégories musicales
        musicCategories: {
            genre: 'Genre',
            emotion: 'Émotion',
            instrument: 'Instrument',
        },
        shop: 'Boutique',
        footer_home: 'Accueil',
        laboratory: "Kit d'outils",
        mobile_bottom_nav: 'Navigation inférieure mobile',
        profile: '', // Pending alignment
    },
    de: {
        menu: 'Menü',
        next_billing_date: 'Mitgliedschaftszeitraum:',
        startVip: 'Upgrade',
        vipBenefits: 'Mehr Vorteile',
        planEntry: 'Einstiegsplan',
        planBasic: 'Basis-Plan',
        planPro: 'Pro-Plan',
        freeUser: 'Kostenloser Benutzer',
        home: 'Startseite',
        recentlyUsed: 'Zuletzt verwendet',
        recentlyUsedDesc: 'Aufzeichnungen der letzten 20 besuchten Seiten',
        recentlyUsedEmpty: 'Keine Besuchsaufzeichnungen',
        recentlyUsedClear: 'Alle löschen',
        timeJustNow: 'Gerade eben',
        timeMinutesAgo: 'Vor {n}m',
        timeHoursAgo: 'Vor {n}h',
        explore: 'Erkunden',
        digitalHuman: 'Digitaler Mensch',
        AIImages: 'KI-Bilder',
        AIVideo: 'KI-Video',
        AITools: 'Bearbeitungs-Toolkit',
        AIMusic: 'KI-Musik',
        MyCreations: 'Meine Kreationen',
        textToImage: 'Text zu Bild',
        imageToImage: 'Bild zu Bild',
        textToVideo: 'Text zu Video',
        imageToVideo: 'Bild zu Video',
        imageUpscaler: 'Bildverbesserung',
        videoToVideo: 'Video zu Video',
        createNew: 'Neu Erstellen',
        Creation: 'Kreation',
        // Create Modal
        createModal: {
            video: 'Video',
            image: 'Bild',
            music: 'Musik',
            imageToVideo: 'Bild zu Video',
            textToVideo: 'Text zu Video',
            videoEditor: 'Video-Editor',
            textToImage: 'Text zu Bild',
            imageToImage: 'Bild zu Bild',
        },
        logout: 'Abmelden',
        // Explore page
        explorePage: {
            imageInspiration: 'Bild-Inspiration',
            videoInspiration: 'Video-Inspiration',
            musicInspiration: 'Musik-Inspiration',
            loading: 'Laden',
            pleaseWait: 'Bitte warten...',
            loadFailed: 'Laden fehlgeschlagen, bitte versuchen Sie es erneut',
            noMore: 'Keine weiteren Inhalte',
            noContent: 'Kein Inspirationsinhalt',
        },
        // AppHeader specific translations
        videoAI: 'Video KI',
        imageAI: 'Bild KI',
        aiTools: 'Bearbeitungs-Toolkit',
        pricingLink: 'Preise',
        login: 'Anmelden',
        startFree: 'Kostenlos Starten',
        language: 'Sprache',
        // Language options
        chinese: '中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        billing: 'Abrechnung',
        addDiscount: '+50% Rabatt',
        hot: 'Am meisten beliebt',
        prompt: 'Prompt',
        promptPlaceholder:
            'Beschreiben Sie den Bildinhalt, den Sie generieren möchten...',
        creating: 'Wird erstellt...',
        create: 'Erstellen',
        wanAI: 'Wan AI',
        videoEffects: 'Videoeffekte',
        photoEffects: 'Fotoeffekte',
        effects: 'AI EFFEKTE',
        music: 'Musik',
        generateMusic: 'Musik generieren',
        // Mobile Verlaufseingabe bezogen
        inputPlaceholder: 'Was möchten Sie erstellen?',
        switchCreateType: 'Erstellungstyp wechseln',
        imageCategory: 'Bild',
        videoCategory: 'Video',
        musicCategory: 'Musik',
        characterImage: 'Charakterbild',
        imageTemplate: 'Bildvorlage',
        imageTools: 'Bildwerkzeuge',
        characterVideo: 'Charaktervideo',
        videoTemplate: 'Videovorlage',
        videoTools: 'Videowerkzeuge',
        musicGenerate: 'Musik generieren',
        useThisTemplate: 'Diese Vorlage verwenden',
        viewAll: 'Alle anzeigen',
        christmasSpecial: 'Weihnachts-Special',
        tiktokTrend: 'TikTok-Trend',
        dance: 'Tanz',
        newYear: 'Neujahrs-Special',
        viral: 'Viral',
        art: 'Kunst',
        interactive: 'Interaktiv',
        trending: 'Im Trend',
        portrait: 'Porträt',
        artistic: 'Künstlerisch',
        filter: 'Filter',
        aiDancingTitle: 'AI Tanzvideo-Generator',
        aiKissingTitle: 'KI-Kuss-Videogenerator',
        profile: 'Profil',
        up_to_4k_resolution: 'Bis zu 4K-Auflösung',
        any_aspect_ratio: 'Beliebiges Seitenverhältnis',
        smart_online_search: 'Intelligente Online-Suche',
        control_composition: 'Kompositionskontrolle',
        sketch_to_masterpiece: 'Von der Skizze zum Meisterwerk',
        high_res_output: 'Ausgabe in hoher Auflösung',
        // Check-in-bezogen
        signInEarnCredits: 'Check-in und Verdienen',
        dailySignIn: 'Täglicher Check-in',
        consecutiveSignInRewards:
            'Melden Sie sich 7 aufeinanderfolgende Tage an, um bis zu 50 Credits zu verdienen',
        day: 'Tag',
        claim: 'Einfordern',
        claiming: 'Wird eingefordert...',
        claimed: 'Eingefordert',
        rechargeForMoreCredits: 'Aufladen für Mehr Credits',
        grandPrize: 'Preis',
        claimSuccess: 'Erfolgreich eingefordert',
        noSignInAvailable: 'Kein Check-in verfügbar',
        signInFailed:
            'Check-in fehlgeschlagen, bitte versuchen Sie es später erneut',
        expires: 'Läuft ab am',
        discordBound: 'Discord-Konto bereits verknüpft',
        // Seitenleistenkategorien
        image: 'Bild',
        video: 'Video',
        generateMV: 'MV Generieren',
        textToMusic: 'Text zu Musik',
        // AI-Musik-Seite
        aiMusicPage: {
            title: 'Musikgenerierung',
            description:
                'Generieren Sie verschiedene Musikstile basierend auf Inhalten',
            vocalMusic: 'Gesangsmusik',
            instrumental: 'Instrumental',
            exploreStyles: 'Stile Erkunden',
            communityCreations: 'Community-Kreationen',
            vocal: 'Gesang',
            instMusic: 'Instrumental',
            makeSimilar: 'Ähnlich Erstellen',
        },
        aiMusicSection: {
            title: 'KI-Musik',
        },
        // Text-zu-Musik-Seite
        textToMusicPage: {
            pleaseEnterDescription:
                'Bitte geben Sie eine Musikbeschreibung ein oder wählen Sie einen Stil',
            taskSubmitted: 'Musikgenerierungsaufgabe eingereicht',
            submitFailed: 'Übermittlung fehlgeschlagen',
            createFailed:
                'Musikgenerierung fehlgeschlagen, bitte versuchen Sie es erneut',
            referenceAudio: 'Referenz-Audio',
            lyricsPlaceholder:
                'Bitte geben Sie den Songtext ein, unterstützt [Verse], [Chorus] Tags usw.',
        },
        // Musikstil-Enum-Übersetzung
        musicStyles: {
            // Genre
            POP: 'Pop',
            ROCK: 'Rock',
            RAP: 'Rap',
            ELECTRONIC: 'Elektronisch',
            RNB: 'R&B',
            JAZZ: 'Jazz',
            FOLK: 'Folk',
            CLASSIC: 'Klassik',
            WORLD: 'Weltmusik',
        },
        // Musik-Emotion-Enum-Übersetzung
        musicEmotions: {
            HAPPY: 'Fröhlich',
            RELAXED: 'Entspannt',
            WARM: 'Warm',
            ROMANTIC: 'Romantisch',
            TOUCHING: 'Berührend',
            SAD: 'Traurig',
            LONELY: 'Einsam',
            DEPRESSED: 'Deprimiert',
            TENSE: 'Angespannt',
            EXCITED: 'Aufgeregt',
            EPIC: 'Episch',
            MYSTERIOUS: 'Mysteriös',
        },
        // Musik-Instrument-Enum-Übersetzung
        musicInstruments: {
            PIANO: 'Klavier',
            GUITAR: 'Gitarre',
            BASS: 'Bass',
            DRUMS: 'Schlagzeug',
            STRINGS: 'Streicher',
            WIND: 'Blasinstrumente',
            SYNTHESIZER: 'Synthesizer',
            ELECTRONIC_SOUND: 'Elektronischer Sound',
            FOLK_INSTRUMENT: 'Volksinstrument',
            MIXED_ORCHESTRATION: 'Gemischte Orchestrierung',
        },
        // Musikkategorie-Tab-Titel
        musicCategories: {
            genre: 'Genre',
            emotion: 'Emotion',
            instrument: 'Instrument',
        },
        shop: 'Shop',
        footer_home: 'Home',
        laboratory: 'Toolkit',
        mobile_bottom_nav: 'Mobile untere Navigation',
    },
    ru: {
        menu: 'Меню',
        next_billing_date: 'Период членства:',
        startVip: 'Улучшить тариф',
        vipBenefits: 'Больше преимуществ',
        planEntry: 'Входной план',
        planBasic: 'Базовый план',
        planPro: 'План Pro',
        freeUser: 'Бесплатный пользователь',
        home: 'Главная',
        recentlyUsed: 'Недавние',
        recentlyUsedDesc: 'Записи последних 20 посещённых страниц',
        recentlyUsedEmpty: 'Нет записей о посещениях',
        recentlyUsedClear: 'Очистить всё',
        timeJustNow: 'Только что',
        timeMinutesAgo: '{n}м назад',
        timeHoursAgo: '{n}ч назад',
        explore: 'Исследовать',
        digitalHuman: 'Цифровой Человек',
        AIImages: 'ИИ Изображения',
        AIVideo: 'ИИ Видео',
        AITools: 'Набор инструментов редактирования',
        AIMusic: 'ИИ Музыка',
        MyCreations: 'Мои Творения',
        textToImage: 'Текст в Изображение',
        imageToImage: 'Изображение в Изображение',
        textToVideo: 'Текст в Видео',
        imageToVideo: 'Изображение в Видео',
        imageUpscaler: 'Улучшение Изображений',
        videoToVideo: 'Видео в Видео',
        createNew: 'Создать Новое',
        Creation: 'Творение',
        // Create Modal
        createModal: {
            video: 'Видео',
            image: 'Изображение',
            music: 'Музыка',
            imageToVideo: 'Изображение в Видео',
            textToVideo: 'Текст в Видео',
            videoEditor: 'Редактор Видео',
            textToImage: 'Текст в Изображение',
            imageToImage: 'Изображение в Изображение',
        },
        logout: 'Выйти',
        // Explore page
        explorePage: {
            imageInspiration: 'Вдохновение изображениями',
            videoInspiration: 'Вдохновение видео',
            musicInspiration: 'Музыкальное вдохновение',
            loading: 'Загрузка',
            pleaseWait: 'Пожалуйста, подождите...',
            loadFailed: 'Не удалось загрузить, попробуйте еще раз',
            noMore: 'Больше нет контента',
            noContent: 'Нет контента для вдохновения',
        },
        // AppHeader specific translations
        videoAI: 'Видео ИИ',
        imageAI: 'Изображение ИИ',
        aiTools: 'Набор инструментов редактирования',
        pricingLink: 'Цены',
        login: 'Войти',
        startFree: 'Начать Бесплатно',
        language: 'Язык',
        // Language options
        chinese: '中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        billing: 'Биллинг',
        addDiscount: '+50% Скидка',
        hot: 'Популярное',
        prompt: 'Промпт',
        promptPlaceholder:
            'Опишите содержимое изображения, которое вы хотите создать...',
        creating: 'Создание...',
        create: 'Создать',
        wanAI: 'Wan AI',
        videoEffects: 'Видеоэффекты',
        photoEffects: 'Фотоэффекты',
        effects: 'AI ЭФФЕКТЫ',
        music: 'Музыка',
        generateMusic: 'Создать музыку',
        // Ввод мобильной истории
        inputPlaceholder: 'Что вы хотите создать?',
        switchCreateType: 'Переключить тип создания',
        imageCategory: 'Изображение',
        videoCategory: 'Видео',
        musicCategory: 'Музыка',
        characterImage: 'Изображение персонажа',
        imageTemplate: 'Шаблон изображения',
        imageTools: 'Инструменты изображения',
        characterVideo: 'Видео персонажа',
        videoTemplate: 'Шаблон видео',
        videoTools: 'Видеоинструменты',
        musicGenerate: 'Создать музыку',
        useThisTemplate: 'Использовать этот шаблон',
        viewAll: 'Смотреть все',
        christmasSpecial: 'Рождественский выпуск',
        tiktokTrend: 'Тренд TikTok',
        dance: 'Танец',
        newYear: 'Новогодний выпуск',
        viral: 'Вирусный',
        art: 'Искусство',
        interactive: 'Интерактивный',
        trending: 'В тренде',
        portrait: 'Портрет',
        artistic: 'Художественный',
        filter: 'Фильтр',
        aiDancingTitle: 'Генератор танцевальных видео с ИИ',
        aiKissingTitle: 'Генератор Видео Поцелуев с ИИ',
        profile: 'Профиль',
        up_to_4k_resolution: 'До 4K разрешения',
        any_aspect_ratio: 'Любое соотношение сторон',
        smart_online_search: 'Умный онлайн-поиск',
        control_composition: 'Контроль композиции',
        sketch_to_masterpiece: 'От эскиза к шедевру',
        high_res_output: 'Вывод в высоком разрешении',
        expires: 'Истекает',
        // Связанное с регистрацией
        signInEarnCredits: 'Регистрация и Заработок',
        dailySignIn: 'Ежедневная Регистрация',
        consecutiveSignInRewards:
            'Регистрируйтесь 7 дней подряд, чтобы получить до 50 кредитов',
        day: 'День',
        claim: 'Получить',
        claiming: 'Получение...',
        claimed: 'Получено',
        rechargeForMoreCredits: 'Пополните для Получения Больше Кредитов',
        grandPrize: 'Приз',
        claimSuccess: 'Успешно получено',
        noSignInAvailable: 'Регистрация недоступна',
        signInFailed: 'Регистрация не удалась, пожалуйста, попробуйте позже',
        discordBound: 'Аккаунт Discord уже привязан',
        // Категории боковой панели
        image: 'Изображение',
        video: 'Видео',
        generateMV: 'Создать MV',
        textToMusic: 'Текст в Музыку',
        // Страница AI Музыки
        aiMusicPage: {
            title: 'Генерация Музыки',
            description:
                'Генерировать различные стили музыки на основе контента',
            vocalMusic: 'Вокальная Музыка',
            instrumental: 'Инструментальная',
            exploreStyles: 'Исследовать Стили',
            communityCreations: 'Работы Сообщества',
            vocal: 'Вокал',
            instMusic: 'Инструментал',
            makeSimilar: 'Создать Похожее',
        },
        aiMusicSection: {
            title: 'ИИ Музыка',
        },
        // Страница Текст в Музыку
        textToMusicPage: {
            pleaseEnterDescription:
                'Пожалуйста, введите описание музыки или выберите стиль',
            taskSubmitted: 'Задача генерации музыки отправлена',
            submitFailed: 'Отправка не удалась',
            createFailed:
                'Генерация музыки не удалась, пожалуйста, попробуйте снова',
            referenceAudio: 'Справочное аудио',
            lyricsPlaceholder:
                'Введите текст песни, поддерживаются теги [Verse], [Chorus] и т. д.',
        },
        // Перевод перечисления стилей музыки
        musicStyles: {
            // Жанр
            POP: 'Поп',
            ROCK: 'Рок',
            RAP: 'Рэп',
            ELECTRONIC: 'Электронная',
            RNB: 'R&B',
            JAZZ: 'Джаз',
            FOLK: 'Фолк',
            CLASSIC: 'Классика',
            WORLD: 'Мировая Музыка',
        },
        // Перевод перечисления эмоций музыки
        musicEmotions: {
            HAPPY: 'Счастливый',
            RELAXED: 'Расслабленный',
            WARM: 'Тёплый',
            ROMANTIC: 'Романтичный',
            TOUCHING: 'Трогательный',
            SAD: 'Грустный',
            LONELY: 'Одинокий',
            DEPRESSED: 'Подавленный',
            TENSE: 'Напряжённый',
            EXCITED: 'Возбуждённый',
            EPIC: 'Эпический',
            MYSTERIOUS: 'Таинственный',
        },
        // Перевод перечисления инструментов музыки
        musicInstruments: {
            PIANO: 'Пианино',
            GUITAR: 'Гитара',
            BASS: 'Бас',
            DRUMS: 'Ударные',
            STRINGS: 'Струнные',
            WIND: 'Духовые',
            SYNTHESIZER: 'Синтезатор',
            ELECTRONIC_SOUND: 'Электронный Звук',
            FOLK_INSTRUMENT: 'Народный Инструмент',
            MIXED_ORCHESTRATION: 'Смешанная Оркестровка',
        },
        // Названия вкладок категорий музыки
        musicCategories: {
            genre: 'Жанр',
            emotion: 'Эмоция',
            instrument: 'Инструмент',
        },
        shop: 'Магазин',
        footer_home: 'Главная',
        laboratory: 'Набор инструментов',
        mobile_bottom_nav: 'Мобильная нижняя навигация',
    },
    pt: {
        menu: 'Menu',
        next_billing_date: 'Período de adesão:',
        startVip: 'Fazer Upgrade',
        vipBenefits: 'Mais benefícios',
        planEntry: 'Plano de entrada',
        planBasic: 'Plano básico',
        planPro: 'Plano Pro',
        freeUser: 'Usuário gratuito',
        home: 'Início',
        recentlyUsed: 'Usados recentemente',
        recentlyUsedDesc: 'Registros das últimas 20 páginas visitadas',
        recentlyUsedEmpty: 'Sem registros de visita',
        recentlyUsedClear: 'Limpar tudo',
        timeJustNow: 'Agora mesmo',
        timeMinutesAgo: 'Há {n}m',
        timeHoursAgo: 'Há {n}h',
        explore: 'Explorar',
        digitalHuman: 'Humano Digital',
        AIImages: 'Imagens IA',
        AIVideo: 'Vídeo IA',
        AITools: 'Kit de ferramentas de edição',
        AIMusic: 'IA Música',
        MyCreations: 'Minhas Criações',
        textToImage: 'Texto para Imagem',
        imageToImage: 'Imagem para Imagem',
        textToVideo: 'Texto para Vídeo',
        imageToVideo: 'Imagem para Vídeo',
        imageUpscaler: 'Melhoria de Imagem',
        videoToVideo: 'Vídeo para Vídeo',
        createNew: 'Criar Novo',
        Creation: 'Criação',
        // Create Modal
        createModal: {
            video: 'Vídeo',
            image: 'Imagem',
            music: 'Música',
            imageToVideo: 'Imagem para Vídeo',
            textToVideo: 'Texto para Vídeo',
            videoEditor: 'Editor de Vídeo',
            textToImage: 'Texto para Imagem',
            imageToImage: 'Imagem para Imagem',
        },
        logout: 'Sair',
        // Explore page
        explorePage: {
            imageInspiration: 'Inspiração de Imagem',
            videoInspiration: 'Inspiração de Vídeo',
            musicInspiration: 'Inspiração Musical',
            loading: 'Carregando',
            pleaseWait: 'Por favor aguarde...',
            loadFailed: 'Falha ao carregar, por favor tente novamente',
            noMore: 'Sem mais conteúdo',
            noContent: 'Sem conteúdo de inspiração',
        },
        // AppHeader specific translations
        videoAI: 'Vídeo IA',
        imageAI: 'Imagem IA',
        aiTools: 'Kit de ferramentas de edição',
        pricingLink: 'Preços',
        login: 'Entrar',
        startFree: 'Começar Grátis',
        language: 'Idioma',
        // Language options
        chinese: '中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        billing: 'Faturamento',
        addDiscount: '+50% Desconto',
        hot: 'Mais popular',
        prompt: 'Prompt',
        promptPlaceholder: 'Descreva o conteúdo da imagem que deseja gerar...',
        creating: 'Criando...',
        create: 'Criar',
        wanAI: 'Wan AI',
        videoEffects: 'Efeitos de vídeo',
        photoEffects: 'Efeitos de foto',
        effects: 'AI EFEITOS',
        music: 'Música',
        generateMusic: 'Gerar música',
        // Entrada de histórico móvel relacionada
        inputPlaceholder: 'O que você quer criar?',
        switchCreateType: 'Mudar tipo de criação',
        imageCategory: 'Imagem',
        videoCategory: 'Vídeo',
        musicCategory: 'Música',
        characterImage: 'Imagem de personagem',
        imageTemplate: 'Modelo de imagem',
        imageTools: 'Ferramentas de imagem',
        characterVideo: 'Vídeo de personagem',
        videoTemplate: 'Modelo de vídeo',
        videoTools: 'Ferramentas de vídeo',
        musicGenerate: 'Gerar música',
        useThisTemplate: 'Usar este modelo',
        viewAll: 'Ver todos',
        christmasSpecial: 'Especial de Natal',
        tiktokTrend: 'Tendência TikTok',
        dance: 'Dança',
        newYear: 'Especial de Ano Novo',
        viral: 'Viral',
        art: 'Arte',
        interactive: 'Interativo',
        trending: 'Em alta',
        portrait: 'Retrato',
        artistic: 'Artístico',
        filter: 'Filtro',
        aiDancingTitle: 'Gerador de Vídeo de Dança IA',
        aiKissingTitle: 'Gerador de Vídeos de Beijos com IA',
        profile: 'Perfil',
        up_to_4k_resolution: 'Até resolução 4K',
        any_aspect_ratio: 'Qualquer proporção',
        smart_online_search: 'Pesquisa inteligente online',
        control_composition: 'Controle de composição',
        sketch_to_masterpiece: 'Do esboço à obra-prima',
        high_res_output: 'Saída em alta resolução',
        expires: 'Expira em',
        // Relacionado ao check-in
        signInEarnCredits: 'Check-in e Ganhar',
        dailySignIn: 'Check-in Diário',
        consecutiveSignInRewards:
            'Faça check-in por 7 dias consecutivos para ganhar até 50 créditos',
        day: 'Dia',
        claim: 'Reivindicar',
        claiming: 'Reivindicando...',
        claimed: 'Reivindicado',
        rechargeForMoreCredits: 'Recarregar para Mais Créditos',
        grandPrize: 'Prêmio',
        claimSuccess: 'Reivindicado com sucesso',
        noSignInAvailable: 'Nenhum check-in disponível',
        signInFailed: 'Check-in falhou, por favor tente novamente mais tarde',
        discordBound: 'Conta do Discord já vinculada',
        // Categorias da barra lateral
        image: 'Imagem',
        video: 'Vídeo',
        generateMV: 'Gerar MV',
        textToMusic: 'Texto para Música',
        // Página de AI Música
        aiMusicPage: {
            title: 'Geração de Música',
            description:
                'Gerar diferentes estilos de música com base no conteúdo',
            vocalMusic: 'Música Vocal',
            instrumental: 'Instrumental',
            exploreStyles: 'Explorar Estilos',
            communityCreations: 'Criações da Comunidade',
            vocal: 'Vocal',
            instMusic: 'Instrumental',
            makeSimilar: 'Criar Similar',
        },
        aiMusicSection: {
            title: 'Música IA',
        },
        // Página de Texto para Música
        textToMusicPage: {
            pleaseEnterDescription:
                'Por favor, insira uma descrição de música ou selecione um estilo',
            taskSubmitted: 'Tarefa de geração de música enviada',
            submitFailed: 'Envio falhou',
            createFailed:
                'A geração de música falhou, por favor tente novamente',
            referenceAudio: 'Áudio de Referência',
            lyricsPlaceholder:
                'Insira a letra, suporta etiquetas [Verse], [Chorus], etc.',
        },
        // Tradução de estilos de música
        musicStyles: {
            // Gênero
            POP: 'Pop',
            ROCK: 'Rock',
            RAP: 'Rap',
            ELECTRONIC: 'Eletrônica',
            RNB: 'R&B',
            JAZZ: 'Jazz',
            FOLK: 'Folk',
            CLASSIC: 'Clássica',
            WORLD: 'Música do Mundo',
        },
        // Tradução de emoções musicais
        musicEmotions: {
            HAPPY: 'Feliz',
            RELAXED: 'Relaxado',
            WARM: 'Caloroso',
            ROMANTIC: 'Romântico',
            TOUCHING: 'Comovente',
            SAD: 'Triste',
            LONELY: 'Solitário',
            DEPRESSED: 'Deprimido',
            TENSE: 'Tenso',
            EXCITED: 'Empolgado',
            EPIC: 'Épico',
            MYSTERIOUS: 'Misterioso',
        },
        // Tradução de instrumentos musicais
        musicInstruments: {
            PIANO: 'Piano',
            GUITAR: 'Guitarra',
            BASS: 'Baixo',
            DRUMS: 'Bateria',
            STRINGS: 'Cordas',
            WIND: 'Sopro',
            SYNTHESIZER: 'Sintetizador',
            ELECTRONIC_SOUND: 'Som Eletrônico',
            FOLK_INSTRUMENT: 'Instrumento Folclórico',
            MIXED_ORCHESTRATION: 'Orquestração Mista',
        },
        // Títulos das abas de categorias musicais
        musicCategories: {
            genre: 'Gênero',
            emotion: 'Emoção',
            instrument: 'Instrumento',
        },
        shop: 'Loja',
        footer_home: 'Início',
        laboratory: 'Kit de ferramentas',
        mobile_bottom_nav: 'Navegação inferior móvel',
    },
    it: {
        menu: 'Menu',
        next_billing_date: 'Periodo di adesione:',
        startVip: 'Effettua Upgrade',
        vipBenefits: 'Più vantaggi',
        planEntry: "Piano d'ingresso",
        planBasic: 'Piano base',
        planPro: 'Piano Pro',
        freeUser: 'Utente gratuito',
        home: 'Home',
        recentlyUsed: 'Usati di recente',
        recentlyUsedDesc: 'Registrazioni delle ultime 20 pagine visitate',
        recentlyUsedEmpty: 'Nessun record di visita',
        recentlyUsedClear: 'Cancella tutto',
        timeJustNow: 'Adesso',
        timeMinutesAgo: '{n}m fa',
        timeHoursAgo: '{n}h fa',
        explore: 'Esplora',
        digitalHuman: 'Umano Digitale',
        AIImages: 'Immagini IA',
        AIVideo: 'Video IA',
        AITools: 'Kit di strumenti di modifica',
        AIMusic: 'IA Musica',
        MyCreations: 'Le Mie Creazioni',
        textToImage: 'Testo a Immagine',
        imageToImage: 'Immagine a Immagine',
        textToVideo: 'Testo a Video',
        imageToVideo: 'Immagine a Video',
        imageUpscaler: 'Miglioramento Immagini',
        videoToVideo: 'Video a Video',
        createNew: 'Crea Nuovo',
        Creation: 'Creazione',
        // Create Modal
        createModal: {
            video: 'Video',
            image: 'Immagine',
            music: 'Musica',
            imageToVideo: 'Immagine a Video',
            textToVideo: 'Testo a Video',
            videoEditor: 'Editor Video',
            textToImage: 'Testo a Immagine',
            imageToImage: 'Immagine a Immagine',
        },
        logout: 'Esci',
        // Explore page
        explorePage: {
            imageInspiration: 'Ispirazione Immagine',
            videoInspiration: 'Ispirazione Video',
            musicInspiration: 'Ispirazione Musicale',
            loading: 'Caricamento',
            pleaseWait: 'Attendere prego...',
            loadFailed: 'Caricamento fallito, riprova',
            noMore: 'Nessun altro contenuto',
            noContent: 'Nessun contenuto di ispirazione',
        },
        // AppHeader specific translations
        videoAI: 'Video IA',
        imageAI: 'Immagine IA',
        aiTools: 'Kit di strumenti di modifica',
        pricingLink: 'Prezzi',
        login: 'Accedi',
        startFree: 'Inizia Gratis',
        language: 'Lingua',
        // Language options
        chinese: '中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        billing: 'Fatturazione',
        addDiscount: '+50% Sconto',
        hot: 'Più popolare',
        prompt: 'Prompt',
        promptPlaceholder:
            "Descrivi il contenuto dell'immagine che desideri generare...",
        creating: 'Creazione...',
        create: 'Crea',
        wanAI: 'Wan AI',
        videoEffects: 'Effetti video',
        photoEffects: 'Effetti foto',
        effects: 'AI EFFETTI',
        music: 'Musica',
        generateMusic: 'Genera musica',
        // Input cronologia mobile correlato
        inputPlaceholder: 'Cosa vuoi creare?',
        switchCreateType: 'Cambia tipo di creazione',
        imageCategory: 'Immagine',
        videoCategory: 'Video',
        musicCategory: 'Musica',
        characterImage: 'Immagine del personaggio',
        imageTemplate: 'Modello di immagine',
        imageTools: 'Strumenti immagine',
        characterVideo: 'Video del personaggio',
        videoTemplate: 'Modello video',
        videoTools: 'Strumenti video',
        musicGenerate: 'Genera musica',
        useThisTemplate: 'Usa questo modello',
        viewAll: 'Vedi tutti',
        christmasSpecial: 'Speciale di Natale',
        tiktokTrend: 'Tendenza TikTok',
        dance: 'Danza',
        newYear: 'Speciale di Capodanno',
        viral: 'Virale',
        art: 'Arte',
        interactive: 'Interattivo',
        trending: 'Di tendenza',
        portrait: 'Ritratto',
        artistic: 'Artistico',
        filter: 'Filtro',
        aiDancingTitle: 'Generatore di Video di Danza AI',
        aiKissingTitle: 'Generatore di Video di Baci con IA',
        profile: 'Profilo',
        up_to_4k_resolution: 'Fino alla risoluzione 4K',
        any_aspect_ratio: "Qualsiasi rapporto d'aspetto",
        smart_online_search: 'Ricerca online intelligente',
        control_composition: 'Controllo della composizione',
        sketch_to_masterpiece: 'Dallo schizzo al capolavoro',
        high_res_output: 'Output ad alta risoluzione',
        expires: 'Scade il',
        // Relativo al check-in
        signInEarnCredits: 'Check-in e Guadagna',
        dailySignIn: 'Check-in Giornaliero',
        consecutiveSignInRewards:
            'Effettua il check-in per 7 giorni consecutivi per guadagnare fino a 50 crediti',
        day: 'Giorno',
        claim: 'Rivendica',
        claiming: 'Rivendicazione...',
        claimed: 'Rivendicato',
        rechargeForMoreCredits: 'Ricarica per Più Crediti',
        grandPrize: 'Premio',
        claimSuccess: 'Rivendicato con successo',
        noSignInAvailable: 'Nessun check-in disponibile',
        signInFailed: 'Check-in fallito, per favore riprova più tardi',
        discordBound: 'Account Discord già collegato',
        // Categorie della barra laterale
        image: 'Immagine',
        video: 'Video',
        generateMV: 'Genera MV',
        textToMusic: 'Testo a Musica',
        // Pagina AI Musica
        aiMusicPage: {
            title: 'Generazione Musicale',
            description: 'Genera diversi stili musicali in base al contenuto',
            vocalMusic: 'Musica Vocale',
            instrumental: 'Strumentale',
            exploreStyles: 'Esplora Stili',
            communityCreations: 'Creazioni della Community',
            vocal: 'Vocale',
            instMusic: 'Strumentale',
            makeSimilar: 'Crea Simile',
        },
        aiMusicSection: {
            title: 'Musica IA',
        },
        // Pagina Testo in Musica
        textToMusicPage: {
            pleaseEnterDescription:
                'Inserisci una descrizione musicale o seleziona uno stile',
            taskSubmitted: 'Attività di generazione musicale inviata',
            submitFailed: 'Invio fallito',
            createFailed: 'La generazione musicale è fallita, riprova',
            referenceAudio: 'Audio di Riferimento',
            lyricsPlaceholder:
                'Inserisci il testo, supporta tag [Verse], [Chorus], ecc.',
        },
        // Traduzione enumerazione stili musicali
        musicStyles: {
            // Genere
            POP: 'Pop',
            ROCK: 'Rock',
            RAP: 'Rap',
            ELECTRONIC: 'Elettronica',
            RNB: 'R&B',
            JAZZ: 'Jazz',
            FOLK: 'Folk',
            CLASSIC: 'Classica',
            WORLD: 'Musica del Mondo',
        },
        // Traduzione enumerazione emozioni musicali
        musicEmotions: {
            HAPPY: 'Felice',
            RELAXED: 'Rilassato',
            WARM: 'Caldo',
            ROMANTIC: 'Romantico',
            TOUCHING: 'Commovente',
            SAD: 'Triste',
            LONELY: 'Solitario',
            DEPRESSED: 'Depresso',
            TENSE: 'Teso',
            EXCITED: 'Emozionato',
            EPIC: 'Epico',
            MYSTERIOUS: 'Misterioso',
        },
        // Traduzione enumerazione strumenti musicali
        musicInstruments: {
            PIANO: 'Pianoforte',
            GUITAR: 'Chitarra',
            BASS: 'Basso',
            DRUMS: 'Batteria',
            STRINGS: 'Archi',
            WIND: 'Fiati',
            SYNTHESIZER: 'Sintetizzatore',
            ELECTRONIC_SOUND: 'Suono Elettronico',
            FOLK_INSTRUMENT: 'Strumento Folcloristico',
            MIXED_ORCHESTRATION: 'Orchestrazione Mista',
        },
        // Titoli delle schede delle categorie musicali
        musicCategories: {
            genre: 'Genere',
            emotion: 'Emozione',
            instrument: 'Strumento',
        },
        shop: 'Negozio',
        footer_home: 'Home',
        laboratory: 'Kit di strumenti',
        mobile_bottom_nav: 'Navigazione inferiore mobile',
    },
    ar: {
        menu: 'القائمة',
        next_billing_date: 'فترة العضوية:',
        startVip: 'ترقية الحساب',
        vipBenefits: 'المزيد من المزايا',
        planEntry: 'خطة الدخول',
        planBasic: 'الخطة الأساسية',
        planPro: 'خطة برو',
        freeUser: 'مستخدم مجاني',
        home: 'الرئيسية',
        recentlyUsed: 'المستخدمة مؤخرًا',
        recentlyUsedDesc: 'سجلات آخر 20 صفحة تمت زيارتها',
        recentlyUsedEmpty: 'لا توجد سجلات زيارة',
        recentlyUsedClear: 'مسح الكل',
        timeJustNow: 'الآن',
        timeMinutesAgo: 'منذ {n}د',
        timeHoursAgo: 'منذ {n}س',
        explore: 'استكشف',
        digitalHuman: 'الإنسان الرقمي',
        AIImages: 'صور ذكاء اصطناعي',
        AIVideo: 'فيديو ذكاء اصطناعي',
        AITools: 'مجموعة أدوات التحرير',
        AIMusic: 'موسيقى ذكاء اصطناعي',
        MyCreations: 'إبداعاتي',
        textToImage: 'نص إلى صورة',
        imageToImage: 'صورة إلى صورة',
        textToVideo: 'نص إلى فيديو',
        imageToVideo: 'صورة إلى فيديو',
        imageUpscaler: 'تحسين الصورة',
        videoToVideo: 'فيديو إلى فيديو',
        createNew: 'إنشاء جديد',
        Creation: 'إبداع',
        // Create Modal
        createModal: {
            video: 'فيديو',
            image: 'صورة',
            music: 'موسيقى',
            imageToVideo: 'صورة إلى فيديو',
            textToVideo: 'نص إلى فيديو',
            videoEditor: 'محرر الفيديو',
            textToImage: 'نص إلى صورة',
            imageToImage: 'صورة إلى صورة',
        },
        logout: 'تسجيل الخروج',
        // Explore page
        explorePage: {
            imageInspiration: 'إلهام الصور',
            videoInspiration: 'إلهام الفيديو',
            musicInspiration: 'إلهام موسيقي',
            loading: 'جاري التحميل',
            pleaseWait: 'يرجى الانتظار...',
            loadFailed: 'فشل التحميل، يرجى المحاولة مرة أخرى',
            noMore: 'لا مزيد من المحتوى',
            noContent: 'لا يوجد محتوى إلهام',
        },
        // AppHeader specific translations
        videoAI: 'فيديو ذكاء اصطناعي',
        imageAI: 'صورة ذكاء اصطناعي',
        aiTools: 'مجموعة أدوات التحرير',
        pricingLink: 'الأسعار',
        login: 'تسجيل الدخول',
        startFree: 'ابدأ مجاناً',
        language: 'اللغة',
        // Language options
        chinese: '中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        billing: 'الفوترة',
        addDiscount: '+50% خصم',
        hot: 'الأكثر شعبية',
        prompt: 'الطلب',
        promptPlaceholder: 'اوصف محتوى الصورة الذي تريد إنشاؤه...',
        creating: 'جارٍ الإنشاء...',
        create: 'إنشاء',
        wanAI: 'Wan AI',
        videoEffects: 'تأثيرات الفيديو',
        photoEffects: 'تأثيرات الصور',
        effects: 'AI تأثيرات',
        music: 'موسيقى',
        generateMusic: 'إنشاء موسيقى',
        useThisTemplate: 'استخدم هذا القالب',
        viewAll: 'عرض الكل',
        christmasSpecial: 'عرض خاص بعيد الميلاد',
        tiktokTrend: 'ترند تيك توك',
        dance: 'رقص',
        newYear: 'عرض خاص بالسنة الجديدة',
        viral: 'فيروسي',
        art: 'فن',
        interactive: 'تفاعلي',
        trending: 'رائج',
        portrait: 'صورة شخصية',
        artistic: 'فني',
        filter: 'فلتر',
        aiDancingTitle: 'مولد فيديو الرقص بالذكاء الاصطناعي',
        aiKissingTitle: 'مولد فيديو القبلات بالذكاء الاصطناعي',
        profile: 'الملف الشخصي',
        up_to_4k_resolution: 'حتى دقة 4K',
        any_aspect_ratio: 'أي نسبة عرض إلى ارتفاع',
        smart_online_search: 'بحث ذكي عبر الإنترنت',
        control_composition: 'التحكم في التكوين',
        sketch_to_masterpiece: 'من رسمٍ تخطيطي إلى تحفة فنية',
        high_res_output: 'إخراج عالي الدقة',
        expires: 'ينتهي في',
        // متعلق بتسجيل الدخول
        signInEarnCredits: 'تسجيل الدخول والكسب',
        dailySignIn: 'تسجيل الدخول اليومي',
        consecutiveSignInRewards:
            'سجل الدخول لمدة 7 أيام متتالية لتحصل على ما يصل إلى 50 رصيدًا',
        day: 'يوم',
        claim: 'المطالبة',
        claiming: 'جاري المطالبة...',
        claimed: 'تم المطالبة',
        rechargeForMoreCredits: 'إعادة الشحن للمزيد من الرصيد',
        grandPrize: 'الجائزة',
        claimSuccess: 'تمت المطالبة بنجاح',
        noSignInAvailable: 'لا يوجد تسجيل دخول متاح',
        signInFailed: 'فشل تسجيل الدخول، يرجى المحاولة مرة أخرى لاحقًا',
        discordBound: 'حساب Discord مرتبط بالفعل',
        // فئات الشريط الجانبي
        image: 'صورة',
        video: 'فيديو',
        generateMV: 'إنشاء MV',
        textToMusic: 'نص إلى موسيقى',
        // صفحة AI الموسيقى
        aiMusicPage: {
            title: 'توليد الموسيقى',
            description: 'إنشاء أنماط موسيقية مختلفة بناءً على المحتوى',
            vocalMusic: 'موسيقى صوتية',
            instrumental: 'آلية',
            exploreStyles: 'استكشف الأنماط',
            communityCreations: 'إبداعات المجتمع',
            vocal: 'صوتي',
            instMusic: 'آلي',
            makeSimilar: 'إنشاء مماثل',
        },
        aiMusicSection: {
            title: 'موسيقى الذكاء الاصطناعي',
        },
        // صفحة النص إلى الموسيقى
        textToMusicPage: {
            pleaseEnterDescription: 'يرجى إدخال وصف الموسيقى أو اختيار نمط',
            taskSubmitted: 'تم إرسال مهمة توليد الموسيقى',
            submitFailed: 'فشل الإرسال',
            createFailed: 'فشل توليد الموسيقى، يرجى المحاولة مرة أخرى',
            referenceAudio: 'ملف صوتي مرجعي',
            lyricsPlaceholder:
                'يرجى إدخال كلمات الأغاني، يدعم علامات [Verse] و [Chorus] وما إلى ذلك.',
        },
        // ترجمة تعداد أنماط الموسيقى
        musicStyles: {
            // النوع
            POP: 'بوب',
            ROCK: 'روك',
            RAP: 'راب',
            ELECTRONIC: 'إلكتروني',
            RNB: 'R&B',
            JAZZ: 'جاز',
            FOLK: 'فولك',
            CLASSIC: 'كلاسيكي',
            WORLD: 'موسيقى العالم',
        },
        // ترجمة تعداد مشاعر الموسيقى
        musicEmotions: {
            HAPPY: 'سعيد',
            RELAXED: 'مسترخي',
            WARM: 'دافئ',
            ROMANTIC: 'رومانسي',
            TOUCHING: 'مؤثر',
            SAD: 'حزين',
            LONELY: 'وحيد',
            DEPRESSED: 'مكتئب',
            TENSE: 'متوتر',
            EXCITED: 'متحمس',
            EPIC: 'ملحمي',
            MYSTERIOUS: 'غامض',
        },
        // ترجمة تعداد الآلات الموسيقية
        musicInstruments: {
            PIANO: 'بيانو',
            GUITAR: 'جيتار',
            BASS: 'باس',
            DRUMS: 'طبول',
            STRINGS: 'وتريات',
            WIND: 'آلات النفخ',
            SYNTHESIZER: 'سينثسايزر',
            ELECTRONIC_SOUND: 'صوت إلكتروني',
            FOLK_INSTRUMENT: 'آلة شعبية',
            MIXED_ORCHESTRATION: 'أوركسترا مختلطة',
        },
        // عناوين تبويبات فئات الموسيقى
        musicCategories: {
            genre: 'النوع',
            emotion: 'المشاعر',
            instrument: 'الآلة',
        },
        shop: 'المتجر',
        footer_home: 'الرئيسية',
        laboratory: 'مجموعة أدوات',
        mobile_bottom_nav: 'التنقل السفلي للهاتف المحمول',
    },
    // 泰语
    th: {
        menu: 'เมนู',
        next_billing_date: 'สมาชิกหมดอายุวันที่:',
        startVip: 'อัปเกรดเลย',
        vipBenefits: 'สิทธิประโยชน์เพิ่มเติม',
        planEntry: 'เริ่มต้น',
        planBasic: 'พื้นฐาน',
        planPro: 'โปร',
        freeUser: 'ผู้ใช้ฟรี',
        home: 'หน้าแรก',
        recentlyUsed: 'ที่ใช้ล่าสุด',
        recentlyUsedDesc: 'บันทึกหน้าที่เข้าชมล่าสุด 20 หน้า',
        recentlyUsedEmpty: 'ไม่มีบันทึกการเข้าชม',
        recentlyUsedClear: 'ล้างทั้งหมด',
        timeJustNow: 'เมื่อสักครู่',
        timeMinutesAgo: '{n}นาทีที่แล้ว',
        timeHoursAgo: '{n}ชั่วโมงที่แล้ว',
        explore: 'สำรวจ',
        digitalHuman: 'ตัวละคร',
        AIImages: 'AI ภาพ',
        AIVideo: 'AI วิดีโอ',
        AITools: 'เครื่องมือแก้ไข',
        AIMusic: 'AI เพลง',
        MyCreations: 'ผลงานของฉัน',
        textToImage: 'ข้อความเป็นภาพ',
        imageToImage: 'ภาพเป็นภาพ',
        textToVideo: 'ข้อความเป็นวิดีโอ',
        imageToVideo: 'ภาพเป็นวิดีโอ',
        imageUpscaler: 'เพิ่มความชัดภาพ',
        createNew: 'สร้างใหม่',
        Creation: 'การสร้าง',
        videoToVideo: 'แก้ไขวิดีโอ',
        createModal: {
            video: 'วิดีโอ',
            image: 'รูปภาพ',
            music: 'เพลง',
            imageToVideo: 'รูปภาพเป็นวิดีโอ',
            textToVideo: 'ข้อความเป็นวิดีโอ',
            videoEditor: 'ตัดต่อวิดีโอ',
            textToImage: 'ข้อความเป็นรูปภาพ',
            imageToImage: 'รูปภาพเป็นรูปภาพ',
        },
        logout: 'ออกจากระบบ',
        // หน้า Explore
        explorePage: {
            imageInspiration: 'แรงบันดาลใจจากภาพ',
            videoInspiration: 'แรงบันดาลใจจากวิดีโอ',
            musicInspiration: 'แรงบันดาลใจจากเพลง',
            loading: 'กำลังโหลด',
            pleaseWait: 'กรุณารอสักครู่...',
            loadFailed: 'โหลดล้มเหลว กรุณาลองอีกครั้ง',
            noMore: 'ไม่มีเนื้อหาเพิ่มเติม',
            noContent: 'ไม่มีเนื้อหาแรงบันดาลใจ',
        },
        videoAI: 'วิดีโอ AI',
        imageAI: 'ภาพ AI',
        aiTools: 'เครื่องมือ AI',
        pricingLink: 'ราคา',
        login: 'เข้าสู่ระบบ',
        startFree: 'เริ่มฟรี',
        language: 'ภาษา',
        chinese: '简体中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        traditional_chinese: '繁體中文',
        polish: 'Polski',
        thai: 'ภาษาไทย',
        danish: 'Dansk',
        norwegian: 'Norsk bokmål',
        dutch: 'Nederlands',
        indonesian: 'Bahasa Indonesia',
        turkish: 'Türkçe',
        billing: 'การเรียกเก็บเงิน',
        addDiscount: 'ส่วนลด +50%',
        hot: 'ยอดนิยม',
        prompt: 'พรอมต์',
        promptPlaceholder: 'บรรยายภาพที่ต้องการ...',
        creating: 'กำลังสร้าง...',
        create: 'สร้าง',
        wanAI: 'Wan AI',
        videoEffects: 'เอฟเฟกต์วิดีโอ',
        photoEffects: 'เอฟเฟกต์ภาพ',
        effects: 'เอฟเฟกต์ AI',
        useThisTemplate: 'ใช้เทมเพลตนี้',
        viewAll: 'ดูทั้งหมด',
        // Mobile history input related
        inputPlaceholder: 'คุณต้องการสร้างอะไร',
        switchCreateType: 'เปลี่ยนประเภทการสร้าง',
        imageCategory: 'ภาพ',
        videoCategory: 'วิดีโอ',
        musicCategory: 'เพลง',
        characterImage: 'ภาพตัวละคร',
        imageTemplate: 'เทมเพลตภาพ',
        imageTools: 'เครื่องมือภาพ',
        characterVideo: 'วิดีโอตัวละคร',
        videoTemplate: 'เทมเพลตวิดีโอ',
        videoTools: 'เครื่องมือวิดีโอ',
        musicGenerate: 'สร้างเพลง',
        singleImageReference: 'อ้างอิงภาพเดียว',
        addImage: 'เพิ่มภาพ',
        christmasSpecial: 'พิเศษคริสต์มาส',
        tiktokTrend: 'เทรนด์ TikTok',
        dance: 'เต้นรำ',
        newYear: 'พิเศษปีใหม่',
        viral: 'ไวรัล',
        art: 'ศิลปะ',
        interactive: 'โต้ตอบ',
        trending: 'กำลังเทรนด์',
        portrait: 'ภาพบุคคล',
        artistic: 'ศิลปะ',
        filter: 'ฟิลเตอร์',
        aiDancingTitle: 'เครื่องสร้างวิดีโอเต้นรำ AI',
        aiKissingTitle: 'เครื่องสร้างวิดีโอจูบ AI',
        profile: 'โปรไฟล์',
        up_to_4k_resolution: 'ความละเอียดสูงสุด 4K',
        any_aspect_ratio: 'อัตราส่วนภาพใดก็ได้',
        smart_online_search: 'ค้นหาออนไลน์อัจฉริยะ',
        control_composition: 'ควบคุมการจัดองค์ประกอบ',
        sketch_to_masterpiece: 'จากร่างสู่ผลงานชิ้นเอก',
        high_res_output: 'เอาต์พุตความละเอียดสูง',
        expires: 'หมดอายุ',
        signInEarnCredits: 'เช็คอินรับเครดิต',
        dailySignIn: 'เช็คอินรายวัน',
        consecutiveSignInRewards: 'เช็คอิน 7 วันติดต่อกันรับสูงสุด 50 เครดิต',
        day: 'วัน',
        claim: 'รับ',
        claiming: 'กำลังรับ...',
        claimed: 'รับแล้ว',
        rechargeForMoreCredits: 'เติมเงินรับเครดิตเพิ่ม',
        grandPrize: 'รางวัลใหญ่',
        claimSuccess: 'รับสำเร็จ',
        noSignInAvailable: 'ไม่มีการเช็คอิน',
        signInFailed: 'เช็คอินล้มเหลว กรุณาลองใหม่ภายหลัง',
        image: 'รูปภาพ',
        video: 'วิดีโอ',
        music: 'เพลง',
        generateMusic: 'สร้างเพลง',
        generateMV: 'สร้าง MV',
        textToMusic: 'ข้อความเป็นเพลง',
        aiMusicPage: {
            title: 'สร้างเพลง',
            description: 'สร้างเพลงหลากหลายสไตล์ตามเนื้อหา',
            vocalMusic: 'เพลงมีเสียงร้อง',
            instrumental: 'เพลงบรรเลง',
            exploreStyles: 'สำรวจสไตล์',
            communityCreations: 'ผลงานชุมชน',
            vocal: 'เสียงร้อง',
            instMusic: 'บรรเลง',
            makeSimilar: 'สร้างแบบเดียวกัน',
        },
        aiMusicSection: {
            title: 'เพลง AI',
        },
        textToMusicPage: {
            pleaseEnterDescription: 'กรุณาใส่คำอธิบายเพลงหรือเลือกสไตล์',
            taskSubmitted: 'ส่งงานสร้างเพลงแล้ว',
            submitFailed: 'ส่งล้มเหลว',
            createFailed: 'สร้างเพลงล้มเหลว กรุณาลองใหม่',
            referenceAudio: 'เสียงอ้างอิง',
            lyricsPlaceholder:
                'กรุณาใส่เนื้อเพลง รองรับแท็ก [Verse], [Chorus] ฯลฯ',
        },
        musicStyles: {
            POP: 'ป็อป',
            ROCK: 'ร็อค',
            RAP: 'แร็พ',
            ELECTRONIC: 'อิเล็กทรอนิกส์',
            RNB: 'R&B',
            JAZZ: 'แจ๊ส',
            FOLK: 'โฟล์ค',
            CLASSIC: 'คลาสสิก',
            WORLD: 'เพลงโลก',
        },
        musicEmotions: {
            HAPPY: 'มีความสุข',
            RELAXED: 'ผ่อนคลาย',
            WARM: 'อบอุ่น',
            ROMANTIC: 'โรแมนติก',
            TOUCHING: 'ซาบซึ้ง',
            SAD: 'เศร้า',
            LONELY: 'เหงา',
            DEPRESSED: 'หดหู่',
            TENSE: 'ตึงเครียด',
            EXCITED: 'ตื่นเต้น',
            EPIC: 'มหากาพย์',
            MYSTERIOUS: 'ลึกลับ',
        },
        musicInstruments: {
            PIANO: 'เปียโน',
            GUITAR: 'กีตาร์',
            BASS: 'เบส',
            DRUMS: 'กลอง',
            STRINGS: 'เครื่องสาย',
            WIND: 'เครื่องเป่า',
            SYNTHESIZER: 'ซินธิไซเซอร์',
            ELECTRONIC_SOUND: 'เสียงอิเล็กทรอนิกส์',
            FOLK_INSTRUMENT: 'เครื่องดนตรีพื้นบ้าน',
            MIXED_ORCHESTRATION: 'วงออเคสตราผสม',
        },
        musicCategories: {
            genre: 'แนวเพลง',
            emotion: 'อารมณ์',
            instrument: 'เครื่องดนตรี',
        },
        shop: 'ร้านค้า',
        footer_home: 'หน้าแรก',
        laboratory: 'ชุดเครื่องมือ',
        mobile_bottom_nav: 'แถบนำทางด้านล่างบนมือถือ',
    },
    // 丹麦语
    da: {
        menu: 'Menu',
        next_billing_date: 'Medlemskab udløber d.:',
        startVip: 'Opgrader nu',
        vipBenefits: 'Flere fordele',
        planEntry: 'Intro',
        planBasic: 'Basis',
        planPro: 'Pro',
        freeUser: 'Gratis bruger',
        home: 'Hjem',
        recentlyUsed: 'Senest brugt',
        recentlyUsedDesc: 'Oversigt over de seneste 20 besøgte sider',
        recentlyUsedEmpty: 'Ingen besøgsoptegnelser',
        recentlyUsedClear: 'Ryd alle',
        timeJustNow: 'Lige nu',
        timeMinutesAgo: '{n}min siden',
        timeHoursAgo: '{n}t siden',
        explore: 'Udforsk',
        digitalHuman: 'Karakterer',
        AIImages: 'AI Billeder',
        AIVideo: 'AI Video',
        AITools: 'Værktøjer',
        AIMusic: 'AI Musik',
        MyCreations: 'Mine kreationer',
        textToImage: 'Tekst til billede',
        imageToImage: 'Billede til billede',
        textToVideo: 'Tekst til video',
        imageToVideo: 'Billede til video',
        imageUpscaler: 'Billedforbedring',
        createNew: 'Ny',
        Creation: 'Kreation',
        videoToVideo: 'Videoredigering',
        createModal: {
            video: 'Video',
            image: 'Billede',
            music: 'Musik',
            imageToVideo: 'Billede til video',
            textToVideo: 'Tekst til video',
            videoEditor: 'Videoredigering',
            textToImage: 'Tekst til billede',
            imageToImage: 'Billede til billede',
        },
        logout: 'Log ud',
        // Explore side
        explorePage: {
            imageInspiration: 'Billed inspiration',
            videoInspiration: 'Video inspiration',
            musicInspiration: 'Musik inspiration',
            loading: 'Indlæser',
            pleaseWait: 'Vent venligst...',
            loadFailed: 'Indlæsning mislykkedes, prøv igen',
            noMore: 'Ikke mere indhold',
            noContent: 'Intet inspirationsindhold',
        },
        videoAI: 'Video AI',
        imageAI: 'Billed AI',
        aiTools: 'Værktøjer AI',
        pricingLink: 'Priser',
        login: 'Log ind',
        startFree: 'Start gratis',
        language: 'Sprog',
        chinese: '简体中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        traditional_chinese: '繁體中文',
        polish: 'Polski',
        thai: 'ภาษาไทย',
        danish: 'Dansk',
        norwegian: 'Norsk bokmål',
        dutch: 'Nederlands',
        indonesian: 'Bahasa Indonesia',
        turkish: 'Türkçe',
        billing: 'Fakturering',
        addDiscount: '+50% rabat',
        hot: 'Hot',
        prompt: 'Prompt',
        promptPlaceholder: 'Beskriv billede...',
        creating: 'Genererer...',
        create: 'Opret',
        wanAI: 'Wan AI',
        videoEffects: 'Videoeffekter',
        photoEffects: 'Billedeffekter',
        effects: 'AI Effekter',
        useThisTemplate: 'Brug skabelon',
        viewAll: 'Se alle',
        // Mobile history input related
        inputPlaceholder: 'Hvad vil du skabe',
        switchCreateType: 'Skift kreationstype',
        imageCategory: 'Billede',
        videoCategory: 'Video',
        musicCategory: 'Musik',
        characterImage: 'Karakterbillede',
        imageTemplate: 'Billedskabelon',
        imageTools: 'Billedværktøjer',
        characterVideo: 'Karaktervideo',
        videoTemplate: 'Videoskabelon',
        videoTools: 'Videoværktøjer',
        musicGenerate: 'Generer musik',
        singleImageReference: 'Enkelt billedreference',
        addImage: 'Tilføj billede',
        christmasSpecial: 'Julespecial',
        tiktokTrend: 'TikTok Trend',
        dance: 'Dans',
        newYear: 'Nytårsspecial',
        viral: 'Viral',
        art: 'Kunst',
        interactive: 'Interaktiv',
        trending: 'Trending',
        portrait: 'Portræt',
        artistic: 'Kunstnerisk',
        filter: 'Filter',
        aiDancingTitle: 'AI Dansevideo Generator',
        aiKissingTitle: 'AI Kysvideo Generator',
        profile: 'Profil',
        up_to_4k_resolution: 'Op til 4K opløsning',
        any_aspect_ratio: 'Enhver billedformat',
        smart_online_search: 'Smart onlinesøgning',
        control_composition: 'Kompositionskontrol',
        sketch_to_masterpiece: 'Fra skitse til mesterværk',
        high_res_output: 'Højopløselig output',
        expires: 'Udløber',
        signInEarnCredits: 'Check-in og tjen',
        dailySignIn: 'Daglig check-in',
        consecutiveSignInRewards:
            'Check ind 7 dage i træk og tjen op til 50 kreditter',
        day: 'Dag',
        claim: 'Kræv',
        claiming: 'Kræver...',
        claimed: 'Krævet',
        rechargeForMoreCredits: 'Genoplad for flere kreditter',
        grandPrize: 'Præmie',
        claimSuccess: 'Krævet med succes',
        noSignInAvailable: 'Ingen check-in tilgængelig',
        signInFailed: 'Check-in mislykkedes, prøv igen senere',
        image: 'Billede',
        video: 'Video',
        music: 'Musik',
        generateMusic: 'Generer musik',
        generateMV: 'Generer MV',
        textToMusic: 'Tekst til musik',
        aiMusicPage: {
            title: 'Musikgenerering',
            description: 'Generer forskellige musikstile baseret på indhold',
            vocalMusic: 'Vokalmusik',
            instrumental: 'Instrumental',
            exploreStyles: 'Udforsk stilarter',
            communityCreations: 'Fællesskabskreationer',
            vocal: 'Vokal',
            instMusic: 'Instrumental',
            makeSimilar: 'Lav lignende',
        },
        aiMusicSection: {
            title: 'AI Musik',
        },
        textToMusicPage: {
            pleaseEnterDescription: 'Indtast musikbeskrivelse eller vælg stil',
            taskSubmitted: 'Musikgenereringsopgave indsendt',
            submitFailed: 'Indsendelse mislykkedes',
            createFailed: 'Musikgenerering mislykkedes, prøv igen',
            referenceAudio: 'Referencelyd',
            lyricsPlaceholder:
                'Indtast sangtekster, understøtter [Verse], [Chorus] tags osv.',
        },
        musicStyles: {
            POP: 'Pop',
            ROCK: 'Rock',
            RAP: 'Rap',
            ELECTRONIC: 'Elektronisk',
            RNB: 'R&B',
            JAZZ: 'Jazz',
            FOLK: 'Folk',
            CLASSIC: 'Klassisk',
            WORLD: 'Verdensmusik',
        },
        musicEmotions: {
            HAPPY: 'Glad',
            RELAXED: 'Afslappet',
            WARM: 'Varm',
            ROMANTIC: 'Romantisk',
            TOUCHING: 'Rørende',
            SAD: 'Trist',
            LONELY: 'Ensom',
            DEPRESSED: 'Deprimeret',
            TENSE: 'Anspændt',
            EXCITED: 'Ophidset',
            EPIC: 'Episk',
            MYSTERIOUS: 'Mystisk',
        },
        musicInstruments: {
            PIANO: 'Klaver',
            GUITAR: 'Guitar',
            BASS: 'Bas',
            DRUMS: 'Trommer',
            STRINGS: 'Strygere',
            WIND: 'Blæsere',
            SYNTHESIZER: 'Synthesizer',
            ELECTRONIC_SOUND: 'Elektronisk lyd',
            FOLK_INSTRUMENT: 'Folkemusik instrument',
            MIXED_ORCHESTRATION: 'Blandet orkestrering',
        },
        musicCategories: {
            genre: 'Genre',
            emotion: 'Følelse',
            instrument: 'Instrument',
        },
        shop: 'Butik',
        footer_home: 'Hjem',
        laboratory: 'Værktøjskasse',
        mobile_bottom_nav: 'Mobil bundnavigation',
    },
    // 挪威语
    no: {
        menu: 'Meny',
        next_billing_date: 'Medlemskap utløper d.:',
        startVip: 'Oppgrader nå',
        vipBenefits: 'Flere fordeler',
        planEntry: 'Intro',
        planBasic: 'Basis',
        planPro: 'Pro',
        freeUser: 'Gratis bruker',
        home: 'Hjem',
        recentlyUsed: 'Nylig brukt',
        recentlyUsedDesc: 'Oversikt over de siste 20 besøkte sidene',
        recentlyUsedEmpty: 'Ingen besøksoppføringer',
        recentlyUsedClear: 'Tøm alle',
        timeJustNow: 'Akkurat nå',
        timeMinutesAgo: '{n}min siden',
        timeHoursAgo: '{n}t siden',
        explore: 'Utforsk',
        digitalHuman: 'Karakterer',
        AIImages: 'AI Bilder',
        AIVideo: 'AI Video',
        AITools: 'Verktøy',
        AIMusic: 'AI Musikk',
        MyCreations: 'Mine kreasjoner',
        textToImage: 'Tekst til bilde',
        imageToImage: 'Bilde til bilde',
        textToVideo: 'Tekst til video',
        imageToVideo: 'Bilde til video',
        imageUpscaler: 'Bildefatbedring',
        createNew: 'Ny',
        Creation: 'Kreasjon',
        videoToVideo: 'Videoredigering',
        createModal: {
            video: 'Video',
            image: 'Bilde',
            music: 'Musikk',
            imageToVideo: 'Bilde til video',
            textToVideo: 'Tekst til video',
            videoEditor: 'Videoredigering',
            textToImage: 'Tekst til bilde',
            imageToImage: 'Bilde til bilde',
        },
        logout: 'Logg ut',
        // Explore side
        explorePage: {
            imageInspiration: 'Bilde inspirasjon',
            videoInspiration: 'Video inspirasjon',
            musicInspiration: 'Musikk inspirasjon',
            loading: 'Laster',
            pleaseWait: 'Vennligst vent...',
            loadFailed: 'Lasting mislyktes, prøv igjen',
            noMore: 'Ikke mer innhold',
            noContent: 'Ingen inspirasjon innhold',
        },
        videoAI: 'Video AI',
        imageAI: 'Bilde AI',
        aiTools: 'Verktøy AI',
        pricingLink: 'Priser',
        login: 'Logg inn',
        startFree: 'Start gratis',
        language: 'Språk',
        chinese: '简体中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        traditional_chinese: '繁體中文',
        polish: 'Polski',
        thai: 'ภาษาไทย',
        danish: 'Dansk',
        norwegian: 'Norsk bokmål',
        dutch: 'Nederlands',
        indonesian: 'Bahasa Indonesia',
        turkish: 'Türkçe',
        billing: 'Fakturering',
        addDiscount: '+50% rabatt',
        hot: 'Hot',
        prompt: 'Prompt',
        promptPlaceholder: 'Beskriv bilde...',
        creating: 'Genererer...',
        create: 'Opprett',
        wanAI: 'Wan AI',
        videoEffects: 'Videoeffekter',
        photoEffects: 'Bildeeffekter',
        effects: 'AI Effekter',
        useThisTemplate: 'Bruk mal',
        viewAll: 'Se alle',
        // Mobile history input related
        inputPlaceholder: 'Hva vil du lage',
        switchCreateType: 'Bytt kreasjonstype',
        imageCategory: 'Bilde',
        videoCategory: 'Video',
        musicCategory: 'Musikk',
        characterImage: 'Karakterbilde',
        imageTemplate: 'Bildemal',
        imageTools: 'Bildeverktøy',
        characterVideo: 'Karaktervideo',
        videoTemplate: 'Videomal',
        videoTools: 'Videoverktøy',
        musicGenerate: 'Generer musikk',
        singleImageReference: 'Enkelt bildereferanse',
        addImage: 'Legg til bilde',
        christmasSpecial: 'Julespesial',
        tiktokTrend: 'TikTok Trend',
        dance: 'Dans',
        newYear: 'Nyttårsspesial',
        viral: 'Viral',
        art: 'Kunst',
        interactive: 'Interaktiv',
        trending: 'Trending',
        portrait: 'Portrett',
        artistic: 'Kunstnerisk',
        filter: 'Filter',
        aiDancingTitle: 'AI Dansevideo Generator',
        aiKissingTitle: 'AI Kyssvideo Generator',
        profile: 'Profil',
        up_to_4k_resolution: 'Opptil 4K oppløsning',
        any_aspect_ratio: 'Ethvert sideforhold',
        smart_online_search: 'Smart nettsøk',
        control_composition: 'Komposisjonskontroll',
        sketch_to_masterpiece: 'Fra skisse til mesterverk',
        high_res_output: 'Høyoppløselig utgang',
        expires: 'Utløper',
        signInEarnCredits: 'Sjekk inn og tjen',
        dailySignIn: 'Daglig innsjekking',
        consecutiveSignInRewards:
            'Sjekk inn 7 dager på rad og tjen opptil 50 kreditter',
        day: 'Dag',
        claim: 'Krev',
        claiming: 'Krever...',
        claimed: 'Krevd',
        rechargeForMoreCredits: 'Lad opp for flere kreditter',
        grandPrize: 'Premie',
        claimSuccess: 'Krevd vellykket',
        noSignInAvailable: 'Ingen innsjekking tilgjengelig',
        signInFailed: 'Innsjekking mislyktes, prøv igjen senere',
        image: 'Bilde',
        video: 'Video',
        music: 'Musikk',
        generateMusic: 'Generer musikk',
        generateMV: 'Generer MV',
        textToMusic: 'Tekst til musikk',
        aiMusicPage: {
            title: 'Musikkgenerering',
            description: 'Generer ulike musikkstiler basert på innhold',
            vocalMusic: 'Vokalmusikk',
            instrumental: 'Instrumental',
            exploreStyles: 'Utforsk stiler',
            communityCreations: 'Fellesskapskreasjoner',
            vocal: 'Vokal',
            instMusic: 'Instrumental',
            makeSimilar: 'Lag lignende',
        },
        aiMusicSection: {
            title: 'AI Musikk',
        },
        textToMusicPage: {
            pleaseEnterDescription:
                'Skriv inn musikkbeskrivelse eller velg stil',
            taskSubmitted: 'Musikkgenereringsoppgave sendt',
            submitFailed: 'Innsending mislyktes',
            createFailed: 'Musikkgenerering mislyktes, prøv igjen',
            referenceAudio: 'Referanselyd',
            lyricsPlaceholder:
                'Skriv inn sangtekster, støtter [Verse], [Chorus] tagger osv.',
        },
        musicStyles: {
            POP: 'Pop',
            ROCK: 'Rock',
            RAP: 'Rap',
            ELECTRONIC: 'Elektronisk',
            RNB: 'R&B',
            JAZZ: 'Jazz',
            FOLK: 'Folk',
            CLASSIC: 'Klassisk',
            WORLD: 'Verdensmusikk',
        },
        musicEmotions: {
            HAPPY: 'Glad',
            RELAXED: 'Avslappet',
            WARM: 'Varm',
            ROMANTIC: 'Romantisk',
            TOUCHING: 'Rørende',
            SAD: 'Trist',
            LONELY: 'Ensom',
            DEPRESSED: 'Deprimert',
            TENSE: 'Anspent',
            EXCITED: 'Spent',
            EPIC: 'Episk',
            MYSTERIOUS: 'Mystisk',
        },
        musicInstruments: {
            PIANO: 'Piano',
            GUITAR: 'Gitar',
            BASS: 'Bass',
            DRUMS: 'Trommer',
            STRINGS: 'Strykere',
            WIND: 'Blåsere',
            SYNTHESIZER: 'Synthesizer',
            ELECTRONIC_SOUND: 'Elektronisk lyd',
            FOLK_INSTRUMENT: 'Folkemusikkinstrument',
            MIXED_ORCHESTRATION: 'Blandet orkestrering',
        },
        musicCategories: {
            genre: 'Sjanger',
            emotion: 'Følelse',
            instrument: 'Instrument',
        },
        shop: 'Butikk',
        footer_home: 'Hjem',
        laboratory: 'Verktøysett',
        mobile_bottom_nav: 'Mobil bunnnavigasjon',
    },
    // 荷兰语
    nl: {
        menu: 'Menu',
        next_billing_date: 'Lidmaatschap geldig tot:',
        startVip: 'Nu upgraden',
        vipBenefits: 'Meer voordelen',
        planEntry: 'Intro',
        planBasic: 'Basis',
        planPro: 'Pro',
        freeUser: 'Gratis gebruiker',
        home: 'Home',
        recentlyUsed: 'Recent gebruikt',
        recentlyUsedDesc: "Overzicht van de 20 laatst bezochte pagina's",
        recentlyUsedEmpty: 'Geen bezoekrecords',
        recentlyUsedClear: 'Alles wissen',
        timeJustNow: 'Zojuist',
        timeMinutesAgo: '{n}min geleden',
        timeHoursAgo: '{n}u geleden',
        explore: 'Verkennen',
        digitalHuman: 'Personages',
        AIImages: 'AI Afbeeldingen',
        AIVideo: 'AI Video',
        AITools: 'Bewerkingstools',
        AIMusic: 'AI Muziek',
        MyCreations: 'Mijn creaties',
        textToImage: 'Tekst naar afbeelding',
        imageToImage: 'Afbeelding naar afbeelding',
        textToVideo: 'Tekst naar video',
        imageToVideo: 'Afbeelding naar video',
        imageUpscaler: 'Beeldverbetering',
        createNew: 'Nieuw',
        Creation: 'Creatie',
        videoToVideo: 'Videobewerking',
        createModal: {
            video: 'Video',
            image: 'Afbeelding',
            music: 'Muziek',
            imageToVideo: 'Afbeelding naar video',
            textToVideo: 'Tekst naar video',
            videoEditor: 'Video-editor',
            textToImage: 'Tekst naar afbeelding',
            imageToImage: 'Afbeelding naar afbeelding',
        },
        logout: 'Uitloggen',
        // Explore pagina
        explorePage: {
            imageInspiration: 'Afbeelding inspiratie',
            videoInspiration: 'Video inspiratie',
            musicInspiration: 'Muziek inspiratie',
            loading: 'Laden',
            pleaseWait: 'Even geduld...',
            loadFailed: 'Laden mislukt, probeer opnieuw',
            noMore: 'Geen inhoud meer',
            noContent: 'Geen inspiratie-inhoud',
        },
        videoAI: 'Video AI',
        imageAI: 'Beeld AI',
        aiTools: 'Tools AI',
        pricingLink: 'Prijzen',
        login: 'Inloggen',
        startFree: 'Gratis starten',
        language: 'Taal',
        chinese: '简体中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        traditional_chinese: '繁體中文',
        polish: 'Polski',
        thai: 'ภาษาไทย',
        danish: 'Dansk',
        norwegian: 'Norsk bokmål',
        dutch: 'Nederlands',
        indonesian: 'Bahasa Indonesia',
        turkish: 'Türkçe',
        billing: 'Facturering',
        addDiscount: '+50% korting',
        hot: 'Hot',
        prompt: 'Prompt',
        promptPlaceholder: 'Beschrijf afbeelding...',
        creating: 'Genereren...',
        create: 'Maken',
        wanAI: 'Wan AI',
        videoEffects: 'Video-effecten',
        photoEffects: 'Beeld-effecten',
        effects: 'AI Effecten',
        useThisTemplate: 'Gebruik sjabloon',
        viewAll: 'Bekijk alles',
        // Mobile history input related
        inputPlaceholder: 'Wat wil je maken',
        switchCreateType: 'Wissel creatietype',
        imageCategory: 'Afbeelding',
        videoCategory: 'Video',
        musicCategory: 'Muziek',
        characterImage: 'Karakterafbeelding',
        imageTemplate: 'Afbeeldingssjabloon',
        imageTools: 'Afbeeldingstools',
        characterVideo: 'Karaktervideo',
        videoTemplate: 'Videosjabloon',
        videoTools: 'Videotools',
        musicGenerate: 'Genereer muziek',
        singleImageReference: 'Enkele afbeeldingsreferentie',
        addImage: 'Afbeelding toevoegen',
        christmasSpecial: 'Kerstspecial',
        tiktokTrend: 'TikTok Trend',
        dance: 'Dans',
        newYear: 'Nieuwjaarsspecial',
        viral: 'Viraal',
        art: 'Kunst',
        interactive: 'Interactief',
        trending: 'Trending',
        portrait: 'Portret',
        artistic: 'Artistiek',
        filter: 'Filter',
        aiDancingTitle: 'AI Dansvideo Generator',
        aiKissingTitle: 'AI Kusvideo Generator',
        profile: 'Profiel',
        up_to_4k_resolution: 'Tot 4K resolutie',
        any_aspect_ratio: 'Elke beeldverhouding',
        smart_online_search: 'Slimme online zoeken',
        control_composition: 'Compositiecontrole',
        sketch_to_masterpiece: 'Van schets naar meesterwerk',
        high_res_output: 'Hoge resolutie output',
        expires: 'Verloopt',
        signInEarnCredits: 'Check-in en verdien',
        dailySignIn: 'Dagelijkse check-in',
        consecutiveSignInRewards:
            'Check 7 dagen achter elkaar in en verdien tot 50 credits',
        day: 'Dag',
        claim: 'Claim',
        claiming: 'Claimen...',
        claimed: 'Geclaimd',
        rechargeForMoreCredits: 'Opladen voor meer credits',
        grandPrize: 'Prijs',
        claimSuccess: 'Succesvol geclaimd',
        noSignInAvailable: 'Geen check-in beschikbaar',
        signInFailed: 'Check-in mislukt, probeer het later opnieuw',
        image: 'Afbeelding',
        video: 'Video',
        music: 'Muziek',
        generateMusic: 'Muziek genereren',
        generateMV: 'MV genereren',
        textToMusic: 'Tekst naar muziek',
        aiMusicPage: {
            title: 'Muziekgeneratie',
            description:
                'Genereer verschillende muziekstijlen op basis van inhoud',
            vocalMusic: 'Vocale muziek',
            instrumental: 'Instrumentaal',
            exploreStyles: 'Stijlen verkennen',
            communityCreations: 'Gemeenschapscreaties',
            vocal: 'Vocaal',
            instMusic: 'Instrumentaal',
            makeSimilar: 'Maak vergelijkbaar',
        },
        aiMusicSection: {
            title: 'AI Muziek',
        },
        textToMusicPage: {
            pleaseEnterDescription:
                'Voer muziekbeschrijving in of selecteer stijl',
            taskSubmitted: 'Muziekgeneratietaak ingediend',
            submitFailed: 'Indienen mislukt',
            createFailed: 'Muziekgeneratie mislukt, probeer opnieuw',
            referenceAudio: 'Referentieaudio',
            lyricsPlaceholder:
                'Voer songteksten in, ondersteunt [Verse], [Chorus] tags enz.',
        },
        musicStyles: {
            POP: 'Pop',
            ROCK: 'Rock',
            RAP: 'Rap',
            ELECTRONIC: 'Elektronisch',
            RNB: 'R&B',
            JAZZ: 'Jazz',
            FOLK: 'Folk',
            CLASSIC: 'Klassiek',
            WORLD: 'Wereldmuziek',
        },
        musicEmotions: {
            HAPPY: 'Blij',
            RELAXED: 'Ontspannen',
            WARM: 'Warm',
            ROMANTIC: 'Romantisch',
            TOUCHING: 'Ontroerend',
            SAD: 'Verdrietig',
            LONELY: 'Eenzaam',
            DEPRESSED: 'Depressief',
            TENSE: 'Gespannen',
            EXCITED: 'Opgewonden',
            EPIC: 'Episch',
            MYSTERIOUS: 'Mysterieus',
        },
        musicInstruments: {
            PIANO: 'Piano',
            GUITAR: 'Gitaar',
            BASS: 'Bas',
            DRUMS: 'Drums',
            STRINGS: 'Strijkers',
            WIND: 'Blazers',
            SYNTHESIZER: 'Synthesizer',
            ELECTRONIC_SOUND: 'Elektronisch geluid',
            FOLK_INSTRUMENT: 'Volksmuziek instrument',
            MIXED_ORCHESTRATION: 'Gemengde orkestratie',
        },
        musicCategories: {
            genre: 'Genre',
            emotion: 'Emotie',
            instrument: 'Instrument',
        },
        shop: 'Winkel',
        footer_home: 'Home',
        laboratory: 'Toolkit',
        mobile_bottom_nav: 'Mobiele onderste navigatie',
    },
    // 印尼语
    id: {
        menu: 'Menu',
        next_billing_date: 'Keanggotaan berlaku hingga:',
        startVip: 'Tingkatkan Sekarang',
        vipBenefits: 'Lebih Banyak Manfaat',
        planEntry: 'Pemula',
        planBasic: 'Dasar',
        planPro: 'Pro',
        freeUser: 'Pengguna Gratis',
        home: 'Beranda',
        recentlyUsed: 'Terakhir Digunakan',
        recentlyUsedDesc: 'Catatan 20 halaman yang terakhir dikunjungi',
        recentlyUsedEmpty: 'Tidak ada catatan kunjungan',
        recentlyUsedClear: 'Hapus Semua',
        timeJustNow: 'Baru saja',
        timeMinutesAgo: '{n}mnt yang lalu',
        timeHoursAgo: '{n}jam yang lalu',
        explore: 'Jelajahi',
        digitalHuman: 'Karakter',
        AIImages: 'AI Gambar',
        AIVideo: 'AI Video',
        AITools: 'Toolkit Editor',
        AIMusic: 'AI Musik',
        MyCreations: 'Kreasi Saya',
        textToImage: 'Teks ke Gambar',
        imageToImage: 'Gambar ke Gambar',
        textToVideo: 'Teks ke Video',
        imageToVideo: 'Gambar ke Video',
        imageUpscaler: 'Peningkat Gambar',
        createNew: 'Baru',
        Creation: 'Kreasi',
        videoToVideo: 'Edit Video',
        createModal: {
            video: 'Video',
            image: 'Gambar',
            music: 'Musik',
            imageToVideo: 'Gambar ke Video',
            textToVideo: 'Teks ke Video',
            videoEditor: 'Editor Video',
            textToImage: 'Teks ke Gambar',
            imageToImage: 'Gambar ke Gambar',
        },
        logout: 'Keluar',
        // Halaman Explore
        explorePage: {
            imageInspiration: 'Inspirasi Gambar',
            videoInspiration: 'Inspirasi Video',
            musicInspiration: 'Inspirasi Musik',
            loading: 'Memuat',
            pleaseWait: 'Mohon tunggu...',
            loadFailed: 'Gagal memuat, coba lagi',
            noMore: 'Tidak ada konten lagi',
            noContent: 'Tidak ada konten inspirasi',
        },
        videoAI: 'Video AI',
        imageAI: 'Gambar AI',
        aiTools: 'Alat AI',
        pricingLink: 'Harga',
        login: 'Masuk',
        startFree: 'Mulai Gratis',
        language: 'Bahasa',
        chinese: '简体中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        traditional_chinese: '繁體中文',
        polish: 'Polski',
        thai: 'ภาษาไทย',
        danish: 'Dansk',
        norwegian: 'Norsk bokmål',
        dutch: 'Nederlands',
        indonesian: 'Bahasa Indonesia',
        turkish: 'Türkçe',
        billing: 'Penagihan',
        addDiscount: 'Diskon +50%',
        hot: 'Populer',
        prompt: 'Prompt',
        promptPlaceholder: 'Deskripsikan gambar...',
        creating: 'Menghasilkan...',
        create: 'Buat',
        wanAI: 'Wan AI',
        videoEffects: 'Efek Video',
        photoEffects: 'Efek Gambar',
        effects: 'Efek AI',
        useThisTemplate: 'Gunakan Templat',
        viewAll: 'Lihat Semua',
        christmasSpecial: 'Spesial Natal',
        tiktokTrend: 'Tren TikTok',
        dance: 'Tarian',
        newYear: 'Spesial Tahun Baru',
        viral: 'Viral',
        art: 'Seni',
        interactive: 'Interaktif',
        trending: 'Trending',
        portrait: 'Potret',
        artistic: 'Artistik',
        filter: 'Filter',
        aiDancingTitle: 'Generator Video Tarian AI',
        aiKissingTitle: 'Generator Video Ciuman AI',
        profile: 'Profil',
        up_to_4k_resolution: 'Hingga resolusi 4K',
        any_aspect_ratio: 'Rasio aspek apa pun',
        smart_online_search: 'Pencarian online cerdas',
        control_composition: 'Kontrol komposisi',
        sketch_to_masterpiece: 'Dari sketsa ke mahakarya',
        high_res_output: 'Output resolusi tinggi',
        expires: 'Berakhir',
        signInEarnCredits: 'Check-in dan Dapatkan',
        dailySignIn: 'Check-in Harian',
        consecutiveSignInRewards:
            'Check-in 7 hari berturut-turut untuk mendapatkan hingga 50 kredit',
        day: 'Hari',
        claim: 'Klaim',
        claiming: 'Mengklaim...',
        claimed: 'Diklaim',
        rechargeForMoreCredits: 'Isi ulang untuk lebih banyak kredit',
        grandPrize: 'Hadiah',
        claimSuccess: 'Berhasil diklaim',
        noSignInAvailable: 'Tidak ada check-in tersedia',
        signInFailed: 'Check-in gagal, silakan coba lagi nanti',
        image: 'Gambar',
        video: 'Video',
        music: 'Musik',
        generateMusic: 'Buat Musik',
        // Input riwayat mobile terkait
        inputPlaceholder: 'Apa yang ingin Anda buat?',
        switchCreateType: 'Ganti jenis kreasi',
        imageCategory: 'Gambar',
        videoCategory: 'Video',
        musicCategory: 'Musik',
        characterImage: 'Gambar Karakter',
        imageTemplate: 'Template Gambar',
        imageTools: 'Alat Gambar',
        characterVideo: 'Video Karakter',
        videoTemplate: 'Template Video',
        videoTools: 'Alat Video',
        musicGenerate: 'Buat Musik',
        generateMV: 'Buat MV',
        textToMusic: 'Teks ke Musik',
        aiMusicPage: {
            title: 'Pembuatan Musik',
            description: 'Buat berbagai gaya musik berdasarkan konten',
            vocalMusic: 'Musik Vokal',
            instrumental: 'Instrumental',
            exploreStyles: 'Jelajahi Gaya',
            communityCreations: 'Kreasi Komunitas',
            vocal: 'Vokal',
            instMusic: 'Instrumental',
            makeSimilar: 'Buat Serupa',
        },
        aiMusicSection: {
            title: 'Musik AI',
        },
        textToMusicPage: {
            pleaseEnterDescription: 'Masukkan deskripsi musik atau pilih gaya',
            taskSubmitted: 'Tugas pembuatan musik terkirim',
            submitFailed: 'Pengiriman gagal',
            createFailed: 'Pembuatan musik gagal, silakan coba lagi',
            referenceAudio: 'Audio Referensi',
            lyricsPlaceholder:
                'Masukkan lirik, mendukung tag [Verse], [Chorus] dll.',
        },
        musicStyles: {
            POP: 'Pop',
            ROCK: 'Rock',
            RAP: 'Rap',
            ELECTRONIC: 'Elektronik',
            RNB: 'R&B',
            JAZZ: 'Jazz',
            FOLK: 'Folk',
            CLASSIC: 'Klasik',
            WORLD: 'Musik Dunia',
        },
        musicEmotions: {
            HAPPY: 'Bahagia',
            RELAXED: 'Santai',
            WARM: 'Hangat',
            ROMANTIC: 'Romantis',
            TOUCHING: 'Menyentuh',
            SAD: 'Sedih',
            LONELY: 'Kesepian',
            DEPRESSED: 'Tertekan',
            TENSE: 'Tegang',
            EXCITED: 'Bersemangat',
            EPIC: 'Epik',
            MYSTERIOUS: 'Misterius',
        },
        musicInstruments: {
            PIANO: 'Piano',
            GUITAR: 'Gitar',
            BASS: 'Bass',
            DRUMS: 'Drum',
            STRINGS: 'Senar',
            WIND: 'Tiup',
            SYNTHESIZER: 'Synthesizer',
            ELECTRONIC_SOUND: 'Suara Elektronik',
            FOLK_INSTRUMENT: 'Instrumen Rakyat',
            MIXED_ORCHESTRATION: 'Orkestrasi Campuran',
        },
        musicCategories: {
            genre: 'Genre',
            emotion: 'Emosi',
            instrument: 'Instrumen',
        },
        shop: 'Toko',
        footer_home: 'Beranda',
        laboratory: 'Kotak Alat',
        mobile_bottom_nav: 'Navigasi Bawah Seluler',
    },
    // 土耳其语
    tr: {
        menu: 'Menü',
        next_billing_date: 'Üyelik bitiş tarihi:',
        startVip: 'Şimdi Yükselt',
        vipBenefits: 'Daha Fazla Avantaj',
        planEntry: 'Giriş',
        planBasic: 'Temel',
        planPro: 'Pro',
        freeUser: 'Ücretsiz Kullanıcı',
        home: 'Ana Sayfa',
        recentlyUsed: 'Son Kullanılanlar',
        recentlyUsedDesc: 'Son ziyaret edilen 20 sayfanın kaydı',
        recentlyUsedEmpty: 'Ziyaret kaydı yok',
        recentlyUsedClear: 'Tümünü Temizle',
        timeJustNow: 'Az önce',
        timeMinutesAgo: '{n}dk önce',
        timeHoursAgo: '{n}sa önce',
        explore: 'Keşfet',
        digitalHuman: 'Karakterler',
        AIImages: 'AI Görseller',
        AIVideo: 'AI Video',
        AITools: 'Araçlar',
        AIMusic: 'AI Müzik',
        MyCreations: 'Çalışmalarım',
        textToImage: 'Metinden Görsele',
        imageToImage: 'Görselden Görsele',
        textToVideo: 'Metinden Videoya',
        imageToVideo: 'Görselden Videoya',
        imageUpscaler: 'Görsel İyileştirme',
        createNew: 'Yeni',
        Creation: 'Oluşturma',
        videoToVideo: 'Video Düzenleme',
        createModal: {
            video: 'Video',
            image: 'Görsel',
            music: 'Müzik',
            imageToVideo: 'Görselden Video',
            textToVideo: 'Metinden Video',
            videoEditor: 'Video Düzenleyici',
            textToImage: 'Metinden Görsel',
            imageToImage: 'Görselden Görsel',
        },
        logout: 'Çıkış Yap',
        // Keşfet sayfası
        explorePage: {
            imageInspiration: 'Görsel İlham',
            videoInspiration: 'Video İlham',
            musicInspiration: 'Müzik İlham',
            loading: 'Yükleniyor',
            pleaseWait: 'Lütfen bekleyin...',
            loadFailed: 'Yükleme başarısız, tekrar deneyin',
            noMore: 'Daha fazla içerik yok',
            noContent: 'İlham içeriği yok',
        },
        videoAI: 'Video AI',
        imageAI: 'Görsel AI',
        aiTools: 'AI Araçları',
        pricingLink: 'Fiyatlandırma',
        login: 'Giriş Yap',
        startFree: 'Ücretsiz Başla',
        language: 'Dil',
        chinese: '简体中文',
        english: 'English',
        japanese: '日本語',
        korean: '한국어',
        spanish: 'Español',
        french: 'Français',
        german: 'Deutsch',
        russian: 'Русский',
        portuguese: 'Português',
        italian: 'Italiano',
        arabic: 'العربية',
        traditional_chinese: '繁體中文',
        polish: 'Polski',
        thai: 'ภาษาไทย',
        danish: 'Dansk',
        norwegian: 'Norsk bokmål',
        dutch: 'Nederlands',
        indonesian: 'Bahasa Indonesia',
        turkish: 'Türkçe',
        billing: 'Faturalandırma',
        addDiscount: '+%50 indirim',
        hot: 'Popüler',
        prompt: 'Prompt',
        promptPlaceholder: 'Görseli tanımlayın...',
        creating: 'Oluşturuluyor...',
        create: 'Oluştur',
        wanAI: 'Wan AI',
        videoEffects: 'Video Efektleri',
        photoEffects: 'Fotoğraf Efektleri',
        effects: 'AI Efektleri',
        useThisTemplate: 'Şablonu Kullan',
        viewAll: 'Tümünü Gör',
        // Mobile history input related
        inputPlaceholder: 'Ne oluşturmak istiyorsunuz',
        switchCreateType: 'Oluşturma Türünü Değiştir',
        imageCategory: 'Görsel',
        videoCategory: 'Video',
        musicCategory: 'Müzik',
        characterImage: 'Karakter Görseli',
        imageTemplate: 'Görsel Şablonu',
        imageTools: 'Görsel Araçları',
        characterVideo: 'Karakter Videosu',
        videoTemplate: 'Video Şablonu',
        videoTools: 'Video Araçları',
        musicGenerate: 'Müzik Oluştur',
        singleImageReference: 'Tek Görsel Referansı',
        addImage: 'Görsel Ekle',
        christmasSpecial: 'Noel Özel',
        tiktokTrend: 'TikTok Trend',
        dance: 'Dans',
        newYear: 'Yeni Yıl Özel',
        viral: 'Viral',
        art: 'Sanat',
        interactive: 'Etkileşimli',
        trending: 'Trend',
        portrait: 'Portre',
        artistic: 'Sanatsal',
        filter: 'Filtre',
        aiDancingTitle: 'AI Dans Videosu Oluşturucu',
        aiKissingTitle: 'AI Öpüşme Videosu Oluşturucu',
        profile: 'Profil',
        up_to_4k_resolution: '4K çözünürlüğe kadar',
        any_aspect_ratio: 'Herhangi bir en boy oranı',
        smart_online_search: 'Akıllı çevrimiçi arama',
        control_composition: 'Kompozisyon kontrolü',
        sketch_to_masterpiece: 'Eskizden şahesere',
        high_res_output: 'Yüksek çözünürlüklü çıktı',
        expires: 'Sona eriyor',
        signInEarnCredits: 'Giriş yap ve kazan',
        dailySignIn: 'Günlük Giriş',
        consecutiveSignInRewards:
            '7 gün üst üste giriş yaparak 50 krediye kadar kazanın',
        day: 'Gün',
        claim: 'Talep Et',
        claiming: 'Talep ediliyor...',
        claimed: 'Talep edildi',
        rechargeForMoreCredits: 'Daha fazla kredi için yükle',
        grandPrize: 'Ödül',
        claimSuccess: 'Başarıyla talep edildi',
        noSignInAvailable: 'Giriş mevcut değil',
        signInFailed: 'Giriş başarısız, lütfen daha sonra tekrar deneyin',
        image: 'Görsel',
        video: 'Video',
        music: 'Müzik',
        generateMusic: 'Müzik Oluştur',
        generateMV: 'MV Oluştur',
        textToMusic: 'Metinden Müzik',
        aiMusicPage: {
            title: 'Müzik Oluşturma',
            description: 'İçeriğe göre farklı müzik stilleri oluşturun',
            vocalMusic: 'Vokal Müzik',
            instrumental: 'Enstrümantal',
            exploreStyles: 'Stilleri Keşfet',
            communityCreations: 'Topluluk Eserleri',
            vocal: 'Vokal',
            instMusic: 'Enstrümantal',
            makeSimilar: 'Benzerini Yap',
        },
        aiMusicSection: {
            title: 'AI Müzik',
        },
        textToMusicPage: {
            pleaseEnterDescription: 'Müzik açıklaması girin veya stil seçin',
            taskSubmitted: 'Müzik oluşturma görevi gönderildi',
            submitFailed: 'Gönderim başarısız',
            createFailed: 'Müzik oluşturma başarısız, lütfen tekrar deneyin',
            referenceAudio: 'Referans Ses',
            lyricsPlaceholder:
                'Şarkı sözlerini girin, [Verse], [Chorus] etiketlerini destekler vb.',
        },
        musicStyles: {
            POP: 'Pop',
            ROCK: 'Rock',
            RAP: 'Rap',
            ELECTRONIC: 'Elektronik',
            RNB: 'R&B',
            JAZZ: 'Caz',
            FOLK: 'Halk',
            CLASSIC: 'Klasik',
            WORLD: 'Dünya Müziği',
        },
        musicEmotions: {
            HAPPY: 'Mutlu',
            RELAXED: 'Rahat',
            WARM: 'Sıcak',
            ROMANTIC: 'Romantik',
            TOUCHING: 'Dokunaklı',
            SAD: 'Üzgün',
            LONELY: 'Yalnız',
            DEPRESSED: 'Depresif',
            TENSE: 'Gergin',
            EXCITED: 'Heyecanlı',
            EPIC: 'Epik',
            MYSTERIOUS: 'Gizemli',
        },
        musicInstruments: {
            PIANO: 'Piyano',
            GUITAR: 'Gitar',
            BASS: 'Bas',
            DRUMS: 'Davul',
            STRINGS: 'Yaylılar',
            WIND: 'Üflemeli',
            SYNTHESIZER: 'Synthesizer',
            ELECTRONIC_SOUND: 'Elektronik Ses',
            FOLK_INSTRUMENT: 'Halk Çalgısı',
            MIXED_ORCHESTRATION: 'Karışık Orkestrasyon',
        },
        musicCategories: {
            genre: 'Tür',
            emotion: 'Duygu',
            instrument: 'Enstrüman',
        },
        shop: 'Mağaza',
        footer_home: 'Ana Sayfa',
        laboratory: 'Araçlar',
        mobile_bottom_nav: 'Mobil Alt Navigasyon',
    },
}
